import moment from "moment/moment";
import logo from "../../src/assets/images/health.jpg";
import rec1 from "../../src/assets/images/recruitment1 .png";
import rec2 from "../../src/assets/images/rec2.png";
import rec3 from "../../src/assets/images/rec3.png";
import rec4 from "../../src/assets/images/rec4.png";
import rec5 from "../../src/assets/images/rec5.png";
import rec6 from "../../src/assets/images/rec6.jpeg";
import aff1 from "../../src/assets/images/aff1.png";
import aff2 from "../../src/assets/images/aff2.jpeg";
import aff3 from "../../src/assets/images/aff3.webp";
import inter1 from "../../src/assets/images/Interview Preperation.jpg";
import inter3 from "../../src/assets/images/Dress Code.jpg";
import inter2 from "../../src/assets/images/Presentation for Interview.jpg";
import inter4 from "../../src/assets/images/Interview Questions.jpg";
import inter5 from "../../src/assets/images/Successful Interview Process.jpg";
import inter6 from "../../src/assets/images/Interview feedback .jpg";
import podcatsLogo from "../../src/assets/images/podcast.jpg";
import industryLogo from "../../src/assets/images/industry.jpg";
import blog from "../assets/images/hrblog1.jpg";
import blog2 from "../assets/images/blog2hr .jpeg";
import blog3 from "../assets/images/tainingImageHr .jpeg";
import blog4 from "../assets/images/bloghr3.jpeg";
import blog5 from "../assets/images/plainingHr .jpeg";
import Popper from "@mui/material/Popper";
import deleteIcon from "../assets/images/bin.png";
import WarningIcon from "../assets/images/warning.png";
import RefreshIcon from "../assets/images/refresh.png";

import blog7 from "../assets/images/blo7.jpeg";
import { useNavigate, useParams } from "react-router-dom";
import { InsertDriveFileOutlined } from "@mui/icons-material";
import {
  csvImage,
  docImage,
  pdfImage,
  wordImage,
  audioImage,
  xlsxImage,
  otherImage,
} from "../assets";
import { Paper } from "@mui/material";
import { useIds } from "../hook/AdminContext";
import dayjs from "dayjs";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);


export const HandlePathNavigate = (path) => {
  window.dispatchEvent(new CustomEvent("app:navigate", { detail: path }));
};
export const handleScrollCalled = (data) => {
  console.log("scroll called", data);
  const todayCell = document?.querySelector(
    `.calendar-workout-card[id="${data}"]`
  ); // Find the DOM element corresponding to today's date
  if (todayCell) {
    console.log(" scrolled");
    todayCell?.scrollIntoView({ behavior: "instant", block: "center" });
  }
};
export const formatEducationRequired = (text) => {
  if (!text) return "";

  return text
    .replace(/_/g, " ") // Replace underscores with spaces
    .split(" ") // Split into words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(" "); // Join words back together
};

export const get_short_string = (str, limit = 30) => {
  return str && str.length < limit ? str : str?.slice(0, limit) + "...";
};

export const decode_markdown = (text) => {
  var outputText = text.replace(/\[(.*?)\]\s?\(.*?\)/g, "$1");
  var replaced = outputText.replace(/\*/g, "");
  return replaced;
};

export const getTimeBasedOnDate = (date, format) => {
  if (!date || !format || date === "1970-01-01T00:00:00.000Z") {
    return "";
  }

  //   const moment = require("moment-timezone");
  const dateTime = moment(date);
  return dateTime.format(format);
};

export function string_avatar(name) {
  if (name) {
    const splitted = name.split(" ");
    if (splitted.length > 1) {
      return `${splitted[0][0]}${splitted[1][0]}`.toUpperCase();
    } else if (splitted.length === 1) {
      return `${splitted[0][0]}`.toUpperCase();
    }
  }
}

export const get_local_preview = (file) => {
  if (file) {
    return URL.createObjectURL(file);
  } else {
    return "";
  }
};

export const is_small_screen = () => {
  if (window.innerWidth < 500) {
    return true;
  } else {
    return false;
  }
};

export const is_small_medium_screen = () => {
  if (window.innerWidth < 767) {
    return true;
  } else {
    return false;
  }
};
export const sourceAccessMap = [
  {
    key: "hospitality",
    title: "Hospitality",
    path: "hospitality/live-job-feed/personal-jobs",
  },
  {
    key: "warehouse",
    title: "Warehouse & Logistics",
    path: "warehouse/live-job-feed/personal-jobs",
  },
  {
    key: "healthcare",
    title: "Healthcare Source",
    path: "healthcare/live-job-feed/personal-jobs",
  },
  {
    key: "office-source",
    title: "Office Source",
    path: "office-source/live-job-feed/personal-jobs",
  },
  {
    key: "retail-source",
    title: "Retail Source",
    path: "retail-source/live-job-feed/personal-jobs",
  },
  {
    key: "food-source",
    title: "Food Source",
    path: "food-source/live-job-feed/personal-jobs",
  },
  {
    key: "construction-source",
    title: "Construction Source",
    path: "construction-source/live-job-feed/personal-jobs",
  },
  {
    key: "fit-out-source",
    title: "Fit out Source",
    path: "fit-out-source/live-job-feed/personal-jobs",
  },
];
export const salaryFrequency = (type) => {
  switch (type) {
    case "Monthly":
      return "month";
    case "Yearly":
      return "year";
    case "Anually":
      return "annually";
    case "Weekly":
      return "week";
    case "Daily":
      return "day";
    case "Hourly":
      return "hour";
    default:
      return "";
  }
};

export const is_LG_screen = () => {
  if (window.innerWidth > 990) {
    return true;
  } else {
    return false;
  }
};
export function htmlDecode(input) {
  var doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
}

export function getReadingTime(text) {
  if (!text) return "0 min read";

  const wordsPerMinute = 200;
  const words = text.trim().split(/\s+/).length;
  const time = words / wordsPerMinute;

  if (time < 1) {
    const seconds = Math.ceil(time * 60);
    return `${seconds} sec read`;
  }

  return `${Math.ceil(time)} min read`;
}

export function checkAndConvertToHTML(str) {
  if (!str) {
    return str;
  } // Only wrap if no tags exist already
  if (!/<\/?[a-z][\s\S]*>/i.test(str)) {
    return str
      .split(/\n+/) // split on one or more newlines
      .filter((line) => line.trim() !== "") // remove empty lines
      .map((line) => `<p>${line}</p>`) // wrap each in <p>
      .join("");
  }
  return str;
}

export function removeExtraSpacesFromHTML(html) {
  return html
    .replace(/&nbsp;/gi, " ")
    .replace(/\s{2,}/g, " ")
    .replace(/\n{2,}/g, "\n")
    .replace(/(<br\s*\/?>\s*){2,}/gi, "<br />")
    .trim();
}
export function CustomPaper(props) {
  return (
    <Paper
      {...props}
      style={{
        ...props.style,
        width: props.style?.width || "100%", // force paper width
        minWidth: props.style?.minWidth || "100%",
      }}
    />
  );
}
export function CustomPopper(props) {
  const anchorEl = props.anchorEl;
  const width = anchorEl ? anchorEl.clientWidth : undefined;

  return (
    <Popper
      {...props}
      style={{
        width: props.anchorEl ? props.anchorEl.clientWidth : undefined,
      }}
      placement="bottom-start"
    />
  );
}

export const get_date_of_user_time_zone = (date, format, user_time_zone) => {
  if (!date || !format || !user_time_zone) {
    return "-";
  }
  // var moment = require("moment-timezone");
  var date_time = moment.tz(date, user_time_zone);

  // var user_date_time = moment.tz(user_time_zone);

  return date_time.format(format);
};

export function getStringifyItem(input) {
  if (typeof input === "string") {
    return input;
  }

  try {
    return JSON.stringify(input);
  } catch (err) {
    return input;
  }
}
export function getStringifyItemWrappedInArray(input) {
  if (typeof input === "string") {
    return input;
  }

  try {
    return JSON.stringify([input]);
  } catch (err) {
    return input;
  }
}

export const COMMUNITY_LEVELS = [
  {
    name: "dynamite",
    title: "Dynamite",
  },
  {
    name: "pta",
    title: "PTA",
  },
  {
    name: "elite",
    title: "Elite",
  },
  {
    name: "mastery",
    title: "Mastery",
  },
];

export const show_proper_words = (text) => {
  if (text === "Hr" || text === "hr") {
    return "HR";
  }
  let replace_string = "";
  if (text) {
    // Replace hyphens and underscores with spaces
    replace_string = text.replace(/[-_]/g, " ");
    // Capitalize the first letter of every word
    replace_string = replace_string
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  return replace_string;
};
export const show_des_data = (text) => {
  if (!text) return "";

  // Handle already properly formatted strings like "5+ Years", "3 Years", etc.
  if (text.includes("Years") || text.includes("Year")) {
    return text; // Return as is if already properly formatted
  }

  // Handle lowercase formatted strings like "5+ years", "3 years", etc.
  if (text.includes("years") || text.includes("year")) {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  // Directly check for "10plusyears"
  if (text.toLowerCase() === "10plusyears") {
    return "10+ Years";
  }

  // Handle "5plusyears", "3plusyears" etc.
  if (text.toLowerCase().includes("plusyears")) {
    const number = text.match(/\d+/);
    if (number) {
      return `${number[0]}+ Years`;
    }
  }

  // Handle "5plusyear", "3plusyear" etc.
  if (text.toLowerCase().includes("plusyear")) {
    const number = text.match(/\d+/);
    if (number) {
      return `${number[0]}+ Year`;
    }
  }

  // Convert "1to3year", "5to7years" → "1-3 years"
  let replace_string = text.replace(/(\d+)t?o?(\d+)/gi, "$1-$2");

  // Remove extra "years" or "year" if already present
  replace_string = replace_string.replace(/\s*years?/gi, "");

  // Ensure proper singular/plural usage with capitalized "Years"
  if (replace_string === "1") {
    replace_string += " Year";
  } else if (!replace_string.includes("+")) {
    replace_string += " Years";
  }

  return replace_string.trim();
};

export const get_blog_type_for_feature = (feature) => {
  if (feature === "hr") {
    return "allow_manage_blogs_hr";
  }
  if (feature === "training-source") {
    return "allow_manage_blogs_training_source";
  }
  if (feature === "mindset-source") {
    return "allow_manage_blogs_mindset_source";
  }
};

export const convertCurrencyToSign = (cur) => {
  let currency = cur.toUpperCase();
  if (currency === "GBP") {
    return "£";
  } else if (currency === "EUR") {
    return "€";
  } else if (currency === "USD") {
    return "$";
  } else {
    return "";
  }
};

export function addCommasToNumber(number) {
  let _number = parseFloat(number);

  if (isNaN(_number)) return number; // return original if it's not a valid number

  let formatted = Number.isInteger(_number)
    ? _number.toFixed(0)
    : _number.toFixed(2);

  return formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const dd_date_format = (date) => {
  return moment(date).format("DD-MM-YYYY");
};
export const handleImageExtensions = (menu) => {
  let val = menu?.map((el) => {
    return '"' + el.substring(1).toLowerCase() + '"' + ",";
  });
  let unique = val?.filter((item, i, ar) => ar.indexOf(item) === i);
  return unique;
};
export const clickAbleUrl = (text) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.split(urlRegex).map((part) => {
    if (part.match(urlRegex)) {
      return (
        <a href={part} target="_blank">
          {part}
        </a>
      );
    }
    return part;
  });
};

export function getFeatureType(source_slug, feature_slug, navbar = []) {
  if (!source_slug || !feature_slug || !Array.isArray(navbar)) {
    return "Blogs";
  }

  // find matching source object
  const sourceObj = navbar.find((item) => item.source_slug === source_slug);
  if (!sourceObj || !Array.isArray(sourceObj.features)) {
    return "Blogs";
  }

  // find matching feature
  const featureObj = sourceObj.features.find(
    (feature) => feature.slug === feature_slug
  );

  return featureObj?.feature_type == "podcast" ? "Podcasts" : "Blogs";
}

export const get_date_with_admin_time_zone = (
  date,
  format,
  admin_time_zone
) => {
  //   var moment = require("moment-timezone");
  var admin_date_time = moment.tz(date, admin_time_zone);
  return admin_date_time.format(format);
};

export function handle_get_time_ago(isoTime) {
  const now = new Date();
  const past = new Date(isoTime);
  const diffMs = now - past; // difference in milliseconds

  const seconds = Math.floor(diffMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  if (seconds < 60) return "Just now";
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;
  if (days < 7) return `${days}d ago`;
  if (weeks < 4) return `${weeks}w ago`;
  if (months < 12) return `${months || 1}mo ago`;
  return `${years}y ago`;
}

// export const get_date_with_admin_time_zone = (
//   date,
//   format,
//   user_time_zone,
//   admin_time_zone
// ) => {
//   //console.log.log(date, "datedate");
//   //console.log.log(format, "formatformat");
//   //console.log.log(user_time_zone, "user_time_zone");
//   //console.log.log(admin_time_zone, "admin_time_zone");
//   var moment = require("moment-timezone");
//   var admin_date_time = moment.tz(date, admin_time_zone);
//   var user_date_time = admin_date_time.clone().tz("ASIA/KARACHI");
//   return admin_date_time.format(format);
// };
export const onboardingBlog = [
  {
    id: 1,
    logo: blog,
    name: "Onboarding",
    description: "First Step in Successful Recruitment",
    introduction:
      "Recruitment doesn’t end when a candidate signs the offer letter. The onboarding process is one of the most critical elements in ensuring that new hires transition smoothly into their roles and become fully integrated into the company’s culture. A well-structured onboarding experience can significantly impact retention rates and employee engagement.",
    whyItMatters: [
      {
        id: 1,
        title: "First Impressions Count",
        description:
          "Onboarding is the first experience a new employee will have with the company. It’s an opportunity to reaffirm their decision to join and to reinforce the company’s values and culture.",
      },
      {
        id: 2,
        title: "Smooth Transition",
        description:
          "Onboarding helps new hires feel prepared for their role. Clear communication about their responsibilities, team dynamics, and company policies ensures a smooth transition into the workplace.",
      },
      {
        id: 3,
        title: "Engagement from Day One",
        description:
          "When employees feel welcomed and supported from the start, they are more likely to engage with their work and stay committed to the company in the long term.",
      },
    ],
    bestPractices: [
      {
        id: 1,
        title: "Pre-boarding",
        description:
          "Begin the onboarding process before the first day, providing new hires with information about the company, role, and team.",
      },
      {
        id: 2,
        title: "Mentorship Programs",
        description:
          "Pairing new employees with a mentor creates a support system and encourages open communication.",
      },
      {
        id: 3,
        title: "Cultural Integration",
        description:
          "Make sure new hires understand the company’s culture and values through interactive activities and team-building exercises.",
      },
    ],

    conclusion:
      "In Ireland’s competitive job market, a seamless onboarding experience can make all the difference when it comes to retaining talent in the long term.",
  },
  {
    id: 2,
    logo: blog2,

    name: "Retention",
    description: "with Long-Term Commitment in Mind",
    introduction:
      "While recruitment focuses on attracting top talent, retention ensures that those new employees remain happy, productive, and loyal to the organisation. The key to successful recruitment is not just about hiring the right candidates, but ensuring they stay with the company once they’ve been hired.",
    whyItMatters: [
      {
        id: 1,
        title: "Setting Expectations Early",
        description:
          "By clearly communicating the company’s expectations, culture, and values during the recruitment process, you ensure that new employees know what to expect. This transparency fosters trust and alignment from the start.",
      },
      {
        id: 2,
        title: "Aligning with Career Goals",
        description:
          "Understanding a candidate's long-term goals during recruitment allows you to offer them opportunities for growth, skill development, and advancement that will keep them engaged.",
      },
      {
        id: 3,
        title: "Creating a Supportive Environment",
        description:
          "Employees who feel valued are more likely to remain with the company. During recruitment, candidates should be introduced to support networks like HR, mentors, and leaders within the organisation.",
      },
    ],
    bestPractices: [
      {
        id: 1,
        title: "Offer Competitive Packages",
        description:
          "In Ireland, where the cost of living and the job market can be competitive, offering attractive salaries, benefits, and work-life balance can help retain employees.",
      },
      {
        id: 2,
        title: "Career Development",
        description:
          "Incorporating learning and growth opportunities into the recruitment conversation shows potential hires that the company is invested in their future.",
      },
      {
        id: 3,
        title: "Regular Feedback",
        description:
          "Encouraging feedback during the recruitment phase and throughout an employee’s journey helps foster engagement and retention.",
      },
    ],
    conclusion:
      "When recruitment efforts focus on long-term retention, companies are more likely to keep high-performing employees who contribute to the company’s overall success.",
  },
  {
    id: 3,
    logo: blog5,

    name: "Training",
    description: "New Hires Up for Success",
    introduction:
      "Training is a crucial part of the recruitment process because it ensures that employees are equipped with the skills and knowledge they need to succeed. This helps them transition from being new hires to high performers who contribute meaningfully to the company’s growth and success.",
    bestPractices: [
      {
        id: 1,

        title: "Structured On-the-Job Training",
        description:
          "Pair new hires with experienced team members for on-the-job training and real-time learning.",
      },
      {
        id: 2,

        title: "Regular Learning Opportunities",
        description:
          "Incorporate both technical and soft skills training into the employee development program.",
      },
      {
        id: 3,

        title: "Clear Training Paths",
        description:
          "Ensure that there’s a clear path for career advancement, with training opportunities that align with the employee’s goals.",
      },
    ],

    whyItMatters: [
      {
        id: 1,

        title: "Skills Matching",
        description:
          "By offering targeted training programs, companies can help employees upskill and align their competencies with the company’s needs, ensuring they remain competitive and effective in their roles.",
      },
      {
        id: 2,

        title: "Increased Employee Confidence",
        description:
          "Effective training boosts employees’ confidence in their abilities and the job itself, reducing the likelihood of turnover.",
      },
      {
        id: 3,

        title: "Fostering Employee Engagement",
        description:
          "When employees are given access to continuous learning and professional development, they are more likely to stay engaged and loyal to the company.",
      },
    ],

    conclusion:
      "In Ireland, where industries are evolving quickly, investing in training during the recruitment process will help ensure that employees are equipped for future challenges, which in turn improves retention and job satisfaction.",
  },
  {
    id: 4,
    logo: blog4,

    name: "Performance Management",
    description: "Ensuring New Hires Align with Company Goals",
    introduction:
      "Effective performance management is essential for ensuring that newly recruited employees remain aligned with the company’s goals. Recruitment is only the first step; the ongoing management and development of new hires ensure they continue to grow, contribute, and stay engaged.",
    whyItMatters: [
      {
        id: 1,

        title: "Clear Expectations",
        description:
          "When recruiting, it’s crucial to set clear performance expectations from the outset. This provides new employees with a roadmap of success, so they understand what is expected of them in their role.",
      },
      {
        id: 2,

        title: "Feedback Loops",
        description:
          "Continuous feedback is essential for both recruitment and retention. It ensures that employees feel supported in their development and can make adjustments to meet the company’s needs.",
      },
      {
        id: 3,

        title: "Setting Goals for Growth",
        description:
          "Incorporating performance-based goals during recruitment allows employees to understand what they can achieve within the company and how they can advance.",
      },
    ],
    bestPractices: [
      {
        id: 1,

        title: "Regular Check-ins",
        description:
          "Regular one-on-one meetings with managers to discuss performance and progress.",
      },
      {
        id: 2,

        title: "Transparent Goal-Setting",
        description:
          "Set SMART goals that are aligned with company objectives and allow employees to track their development.",
      },
      {
        id: 3,

        title: "Recognition and Rewards",
        description:
          "Acknowledge the efforts and achievements of new recruits, which motivates them to continue performing at a high level.",
      },
    ],
    conclusion:
      "Performance management plays a key role in aligning new hires with business goals, ultimately ensuring that they remain engaged and committed to the company’s mission.",
  },
  {
    id: 5,
    logo: blog3,

    name: "Succession Planning",
    description: "Recruiting for the Future",
    introduction:
      "Succession planning may seem like a long-term concern, but it begins with recruitment. Recruiting with an eye toward future leadership and growth is key to building a sustainable organisation. By identifying high-potential candidates during the recruitment process, businesses can ensure they have the talent needed to drive future success.",
    whyItMatters: [
      {
        id: 1,
        title: "Identifying Leadership Potential",
        description:
          "During recruitment, assess candidates for leadership potential, not just their technical skills. This enables you to develop a leadership pipeline that ensures the future success of the organisation.",
      },
      {
        id: 2,
        title: "Cultural Fit",
        description:
          "Recruiting employees who align with the company’s culture and values makes it easier to develop them into leaders who will carry the organisation forward.",
      },
      {
        id: 3,
        title: "Investing in Long-Term Development",
        description:
          "Recruiting employees with an eye toward their long-term development through mentorship and training ensures that succession planning efforts are built on a strong foundation.",
      },
    ],

    bestPractices: [
      {
        id: 1,
        title: "Talent Mapping",
        description:
          "During recruitment, identify future leaders by understanding each candidate’s potential and long-term career goals.",
      },
      {
        id: 2,
        title: "Developing Internal Talent",
        description:
          "Focus on recruiting individuals who can grow within the organisation and take on greater responsibilities over time.",
      },
      {
        id: 3,
        title: "Building a Talent Pool",
        description:
          "Create a diverse talent pool with candidates who have the potential to step into key roles when needed.",
      },
    ],

    conclusion:
      "By considering succession planning during recruitment, businesses ensure that they are prepared for the future, fostering internal leadership and continuity.",
  },
  {
    id: 6,
    logo: blog7,
    name: "Align Employees to Culture",
    description: "Recruiting for the Future",
    introduction:
      "Succession planning may seem like a long-term concern, but it begins with recruitment. Recruiting with an eye toward future leadership and growth is key to building a sustainable organisation. By identifying high-potential candidates during the recruitment process, businesses can ensure they have the talent needed to drive future success.",

    bestPractices: [
      {
        id: 1,
        title: "Clearly Define and Communicate Values",
        description:
          "It’s essential to clearly define the company’s values and communicate them consistently across all levels of the organization. HR should ensure that these values are integrated into the onboarding process, company communications, and regular updates to keep them top of mind.",
      },
      {
        id: 2,
        title: "Lead by Example",
        description:
          "Leadership plays a critical role in modeling company values. When leaders consistently demonstrate the values in their actions and decisions, it sets a powerful example for employees to follow. Employees are more likely to align with the company’s values when they see them actively practiced by those in leadership positions.",
      },
      {
        id: 3,
        title: "Incorporate Values into Hiring and Onboarding",
        description:
          "During recruitment and onboarding, HR should highlight the company’s values to ensure new hires understand what’s expected. By selecting candidates whose personal values align with the organization’s, companies are more likely to find employees who naturally resonate with and embrace the values.",
      },
      {
        id: 4,
        title: "Provide Training and Development",
        description:
          "Regular training and development initiatives can help reinforce company values. HR can organize workshops, seminars, and discussions that focus on these values and their importance to organizational success. Employees should be equipped with the tools to apply these values in their everyday work.",
      },
      {
        id: 5,
        title: "Recognize and Reward Value-Aligned Behavior",
        description:
          "Recognition programs are an effective way to encourage employees to live the company’s values. By acknowledging and rewarding employees who demonstrate behaviors aligned with these values, HR reinforces the importance of the values and motivates others to follow suit.",
      },
      {
        id: 6,
        title: "Create a Supportive Environment",
        description:
          "A culture that supports the company’s values requires open communication, trust, and collaboration. HR should create an environment where employees feel comfortable discussing how they can embody the values in their work. This can be done through team-building activities, open forums, and feedback systems.",
      },
      {
        id: 7,
        title: "Evaluate and Adapt Over Time",
        description:
          "Company values should be revisited periodically to ensure they remain relevant and are still aligned with the company’s goals. HR should solicit feedback from employees to assess how well the values are being embraced and make adjustments where necessary.",
      },
    ],
    conclusion:
      "By considering succession planning during recruitment, businesses ensure that they are prepared for the future, fostering internal leadership and continuity. Aligning employees with company values requires consistent communication, leadership, and support. By clearly defining and reinforcing the values, providing ongoing training, recognizing alignment, and fostering a supportive environment, HR can help employees internalize the values and apply them in their daily work. This alignment leads to a cohesive culture where everyone is working toward the same goals, enhancing organizational success.",
  },
  {
    id: 7,
    logo: blog4,
    name: "Company Values",
    description: "Recruiting for the Future",
    introduction:
      "Creating company values is an essential process that helps define a company’s culture, guide decision-making, and align employees with a common purpose. These values should reflect the organization’s mission, vision, and the behavior it seeks to encourage within the workplace. Developing clear, meaningful values ensures that everyone in the company understands what is important and how they should conduct themselves to achieve collective success.",

    bestPractices: [
      {
        id: 1,
        title: "Identify Core Beliefs and Principles",
        description:
          "Company values should stem from the organization’s mission and vision. They should reflect what the company stands for and what behaviors are prioritized in achieving long-term success.",
      },
      {
        id: 2,
        title: "Involve Leadership and Employees",
        description:
          "Values should be developed with input from leadership and employees to ensure they reflect the perspectives and priorities of the whole company. Collaboration in this process fosters buy-in and commitment.",
      },
      {
        id: 3,
        title: "Make Values Actionable",
        description:
          "Values should be clear, concise, and actionable. Rather than abstract concepts, they should reflect real, everyday behaviors that employees can adopt to demonstrate alignment with the company’s culture.",
      },
      {
        id: 4,
        title: "Integrate Values into the Workplace",
        description:
          "Company values should be integrated into all aspects of the organization—from hiring and training to performance evaluations and recognition. This ensures consistency in decision-making and reinforces their importance.",
      },
      {
        id: 5,
        title: "Evolve with the Company",
        description:
          "As the company grows and changes, its values should be revisited and adapted. Values should reflect both the company's current culture and its aspirations for the future.",
      },
    ],

    conclusion:
      "In conclusion, creating company values is about articulating the principles that will guide the organization’s behavior, culture, and decision-making. By developing values that are actionable, inclusive, and adaptable, companies can ensure that they foster a strong and positive work environment, aligned with both short-term goals and long-term vision. This not only creates a cohesive culture but also drives sustainable success.",
  },
  {
    id: 8,
    logo: blog3,
    name: "Culture of success",
    description: "Recruiting for the Future",
    introduction:
      "Creating company values is an essential process that helps define a company’s culture, guide decision-making, and align employees with a common purpose. These values should reflect the organization’s mission, vision, and the behavior it seeks to encourage within the workplace. Developing clear, meaningful values ensures that everyone in the company understands what is important and how they should conduct themselves to achieve collective success.",

    bestPractices: [
      {
        id: 1,
        title: "Identify Core Beliefs and Principles",
        description:
          "Company values should stem from the organization’s mission and vision. They should reflect what the company stands for and what behaviors are prioritized in achieving long-term success.",
      },
      {
        id: 2,
        title: "Involve Leadership and Employees",
        description:
          "Values should be developed with input from leadership and employees to ensure they reflect the perspectives and priorities of the whole company. Collaboration in this process fosters buy-in and commitment.",
      },
      {
        id: 3,
        title: "Make Values Actionable",
        description:
          "Values should be clear, concise, and actionable. Rather than abstract concepts, they should reflect real, everyday behaviors that employees can adopt to demonstrate alignment with the company’s culture.",
      },
      {
        id: 4,
        title: "Integrate Values into the Workplace",
        description:
          "Company values should be integrated into all aspects of the organization—from hiring and training to performance evaluations and recognition. This ensures consistency in decision-making and reinforces their importance.",
      },
      {
        id: 5,
        title: "Evolve with the Company",
        description:
          "As the company grows and changes, its values should be revisited and adapted. Values should reflect both the company's current culture and its aspirations for the future.",
      },
    ],

    conclusion:
      "In conclusion, creating company values is about articulating the principles that will guide the organization’s behavior, culture, and decision-making. By developing values that are actionable, inclusive, and adaptable, companies can ensure that they foster a strong and positive work environment, aligned with both short-term goals and long-term vision. This not only creates a cohesive culture but also drives sustainable success.",
  },

  {
    id: 9,
    logo: blog4,
    name: "Generation Alpha",
    description: "Preparing Workplaces for the Next Generation",
    introduction:
      "As Generation Alpha begins to enter the workforce, companies and HR professionals must be proactive in understanding their unique traits, expectations, and needs. This generation, born after 2010, is growing up in a digital-first world with a strong emphasis on technology, social issues, and personalized experiences. To effectively attract and retain Gen Alpha talent, companies need to adapt their strategies and workplace culture to meet the demands of this new generation.",

    bestPractices: [
      {
        id: 1,
        title: "Embrace Technology and Digital Integration",
        description:
          "Generation Alpha is the first generation to grow up fully immersed in digital technology. HR must ensure that their workplaces offer advanced technology tools, seamless remote work capabilities, and innovative digital collaboration platforms. The more tech-savvy and adaptable the work environment, the better companies can attract Gen Alpha employees.",
      },
      {
        id: 2,
        title: "Offer Flexible Work Options",
        description:
          "Gen Alpha is expected to value flexibility in their work schedules, preferring hybrid or fully remote work models. HR should consider implementing flexible work policies, such as adjustable hours, remote work options, and work-life integration initiatives, to accommodate these preferences.",
      },
      {
        id: 3,
        title: "Focus on Social Responsibility and Sustainability",
        description:
          "Generation Alpha is growing up in a time of heightened social and environmental awareness. Companies should align their values with the expectations of Gen Alpha by prioritizing sustainability, ethical practices, and social responsibility initiatives. HR can incorporate these values into recruitment strategies and day-to-day operations to attract like-minded talent.",
      },
      {
        id: 4,
        title: "Personalized Career Development and Learning Opportunities",
        description:
          "Gen Alpha will likely expect continuous learning and personal growth throughout their careers. HR should invest in personalized career development programs, mentorship, and upskilling opportunities. Offering learning platforms, on-demand training, and growth tracks will help ensure that employees feel valued and supported in their professional journeys.",
      },
      {
        id: 5,
        title: "Prioritize Mental Health and Well-Being",
        description:
          "As mental health awareness grows, Gen Alpha will likely prioritize workplaces that offer strong mental health support. HR should develop wellness programs that focus on both physical and mental well-being, including stress management resources, access to therapy or counseling, and policies that promote work-life balance and a supportive environment.",
      },
      {
        id: 6,
        title: "Encourage Diversity and Inclusion",
        description:
          "Gen Alpha is likely to be more diverse and globally minded than previous generations. Companies should foster inclusive work environments where diversity is celebrated, and employees feel respected and valued for their unique backgrounds and perspectives. HR can prioritize diversity in hiring, create inclusive workplace policies, and provide training on unconscious bias and inclusion.",
      },
      {
        id: 7,
        title: "Leverage Data and Analytics",
        description:
          "Generation Alpha is accustomed to data-driven experiences and outcomes. HR should use data and analytics to better understand employee needs, measure engagement, and refine recruitment strategies. Tools that track performance, employee satisfaction, and career progression can help HR tailor their efforts to better meet the expectations of this generation.",
      },
    ],

    conclusion:
      "In conclusion, as Generation Alpha enters the workforce, companies and HR professionals must adapt to their tech-savvy, socially conscious, and flexibility-driven preferences. By embracing technology, offering personalized career development, focusing on mental health, and fostering diversity and inclusion, HR can successfully integrate this generation into the workforce and create a thriving, future-ready workplace. Companies that proactively address these needs will be better equipped to attract, engage, and retain top Gen Alpha talent, ensuring long-term success.",
  },
  {
    id: 10,
    logo: blog2,
    name: "Probation Evaluation",
    description: "Preparing Workplaces for the Next Generation",
    introduction:
      "As Generation Alpha begins to enter the workforce, companies and HR professionals must be proactive in understanding their unique traits, expectations, and needs. This generation, born after 2010, is growing up in a digital-first world with a strong emphasis on technology, social issues, and personalized experiences. To effectively attract and retain Gen Alpha talent, companies need to adapt their strategies and workplace culture to meet the demands of this new generation.",

    bestPractices: [
      {
        id: 1,
        title: "Set Clear Expectations from the Start",
        description:
          "Before evaluating an employee, ensure that clear expectations have been set regarding performance, goals, and key responsibilities. HR and managers should work together to define these expectations during the onboarding process to give the employee a clear understanding of what is required.",
      },
      {
        id: 2,
        title: "Regular Check-Ins and Feedback",
        description:
          "Evaluation shouldn’t wait until the end of the probation period. Schedule regular check-ins (e.g., weekly or monthly) to discuss progress, challenges, and feedback. These meetings provide an opportunity for employees to ask questions, seek clarification, and receive guidance, making the evaluation process more constructive.",
      },
      {
        id: 3,
        title: "Assess Job-Specific Skills and Performance",
        description:
          "Evaluate the employee’s ability to perform the core tasks of their role. This includes assessing their technical skills, problem-solving abilities, productivity, and quality of work. Reviewing completed projects or assignments can provide tangible evidence of their performance.",
      },
      {
        id: 4,
        title: "Evaluate Cultural Fit and Soft Skills",
        description:
          "Beyond technical capabilities, evaluate how well the employee fits into the company culture. Assess communication skills, collaboration, adaptability, and their ability to work within a team. Soft skills like reliability, attitude, and initiative are equally important in determining long-term success.",
      },
      {
        id: 5,
        title: "Gather Feedback from Team Members and Colleagues",
        description:
          "A well-rounded evaluation includes feedback from coworkers and team members who interact with the employee regularly. This provides a comprehensive view of the employee’s interpersonal skills, collaboration, and overall impact within the team.",
      },
      {
        id: 6,
        title: "Provide Constructive Feedback and Areas for Improvement",
        description:
          "Provide clear, actionable feedback, highlighting both strengths and areas where improvement is needed. Focus on specific behaviors and examples rather than generalizations. Offer suggestions for development and provide support, such as training or mentorship, to help the employee improve in certain areas.",
      },
      {
        id: 7,
        title: "Assess Employee Engagement and Motivation",
        description:
          "During the probation period, evaluate the employee’s level of engagement and motivation. Are they proactive in their tasks? Do they demonstrate enthusiasm for their role? Assessing their commitment to the organization’s goals will help determine if they are a good long-term fit.",
      },
      {
        id: 8,
        title: "Make a Decision Based on the Evaluation",
        description:
          "After reviewing performance, feedback, and progress throughout the probation period, make a final decision regarding the employee’s status. This could result in confirming the employee’s position, extending the probation period for further evaluation, or ending the employment if the fit is not right.",
      },
    ],

    conclusion:
      "In conclusion, as Generation Alpha enters the workforce, companies and HR professionals must adapt to their tech-savvy, socially conscious, and flexibility-driven preferences. By embracing technology, offering personalized career development, focusing on mental health, and fostering diversity and inclusion, HR can successfully integrate this generation into the workforce and create a thriving, future-ready workplace. Companies that proactively address these needs will be better equipped to attract, engage, and retain top Gen Alpha talent, ensuring long-term success.",
  },
  {
    id: 11,
    logo: blog3,
    name: "Sourcing Candidates",
    description: "Preparing Workplaces for the Next Generation",
    introduction:
      "As Generation Alpha begins to enter the workforce, companies and HR professionals must be proactive in understanding their unique traits, expectations, and needs. This generation, born after 2010, is growing up in a digital-first world with a strong emphasis on technology, social issues, and personalized experiences. To effectively attract and retain Gen Alpha talent, companies need to adapt their strategies and workplace culture to meet the demands of this new generation.",

    bestPractices: [
      {
        id: 1,
        title: "Understanding Job Requirements",
        description:
          "Clearly defining the job description, including necessary skills, qualifications, and experience, helps focus the search on the most suitable candidates.",
      },
      {
        id: 2,
        title: "Utilizing Multiple Sourcing Channels",
        description:
          "Effective sourcing requires using a mix of job boards, social media, recruitment agencies, and employee referrals to expand the talent pool.",
      },
      {
        id: 3,
        title: "Screening and Assessment",
        description:
          "Thoroughly reviewing resumes, conducting interviews, and testing technical and soft skills are essential to ensure candidates align with the company’s needs.",
      },
      {
        id: 4,
        title: "Employer Brand and Candidate Experience",
        description:
          "Building a strong employer brand and providing a positive experience during the hiring process can help attract and retain top talent.",
      },
      {
        id: 5,
        title: "Engaging Passive Candidates",
        description:
          "Maintaining relationships with passive candidates ensures a ready pool of potential hires, even when no immediate openings are available.",
      },
    ],
    conclusion:
      "In conclusion, as Generation Alpha enters the workforce, companies and HR professionals must adapt to their tech-savvy, socially conscious, and flexibility-driven preferences. By embracing technology, offering personalized career development, focusing on mental health, and fostering diversity and inclusion, HR can successfully integrate this generation into the workforce and create a thriving, future-ready workplace. Companies that proactively address these needs will be better equipped to attract, engage, and retain top Gen Alpha talent, ensuring long-term success.",
  },
  {
    id: 12,
    logo: blog,
    name: "Understanding Employment Legislation",
    description: "Preparing Workplaces for the Next Generation",
    introduction:
      "As Generation Alpha begins to enter the workforce, companies and HR professionals must be proactive in understanding their unique traits, expectations, and needs. This generation, born after 2010, is growing up in a digital-first world with a strong emphasis on technology, social issues, and personalized experiences. To effectively attract and retain Gen Alpha talent, companies need to adapt their strategies and workplace culture to meet the demands of this new generation.",

    bestPractices: [
      {
        id: 1,
        title: "Understanding Job Requirements",
        description:
          "Clearly defining the job description, including necessary skills, qualifications, and experience, helps focus the search on the most suitable candidates.",
      },
      {
        id: 2,
        title: "Utilizing Multiple Sourcing Channels",
        description:
          "Effective sourcing requires using a mix of job boards, social media, recruitment agencies, and employee referrals to expand the talent pool.",
      },
      {
        id: 3,
        title: "Screening and Assessment",
        description:
          "Thoroughly reviewing resumes, conducting interviews, and testing technical and soft skills are essential to ensure candidates align with the company’s needs.",
      },
      {
        id: 4,
        title: "Employer Brand and Candidate Experience",
        description:
          "Building a strong employer brand and providing a positive experience during the hiring process can help attract and retain top talent.",
      },
      {
        id: 5,
        title: "Engaging Passive Candidates",
        description:
          "Maintaining relationships with passive candidates ensures a ready pool of potential hires, even when no immediate openings are available.",
      },
      {
        id: 6,
        title: "Understanding the Basics of Employment Legislation",
        description:
          "HR professionals must understand core legal frameworks governing labor rights, discrimination, employee benefits, health and safety, and wage regulations.",
      },
      {
        id: 7,
        title: "Staying Updated with Legal Changes",
        description:
          "Employment laws evolve frequently. Regularly reviewing updates from government agencies, legal publications, and industry groups is crucial for compliance.",
      },
      {
        id: 8,
        title: "Implementing Legal Updates and Adjustments",
        description:
          "Businesses must update policies, procedures, and employee training to ensure compliance with new employment laws and maintain transparency.",
      },
      {
        id: 9,
        title: "Collaboration with Legal Experts",
        description:
          "Working with legal professionals helps organizations navigate employment laws, review policies, and mitigate potential legal risks.",
      },
    ],
    conclusion:
      "In conclusion, as Generation Alpha enters the workforce, companies and HR professionals must adapt to their tech-savvy, socially conscious, and flexibility-driven preferences. By embracing technology, offering personalized career development, focusing on mental health, and fostering diversity and inclusion, HR can successfully integrate this generation into the workforce and create a thriving, future-ready workplace. Companies that proactively address these needs will be better equipped to attract, engage, and retain top Gen Alpha talent, ensuring long-term success.",
  },
];

export function difference_between_two_dates(date1, date2, difference_in) {
  var start_date = moment(date1);
  var end_date = moment(date2);
  var diffBwDates = end_date.diff(start_date, difference_in);
  console.log(diffBwDates); // Output: 181
  return diffBwDates;
}
export const TIME_ZONE_CONVERSION = (
  date,
  format,
  from_time_zone,
  to_time_zone
) => {
  console.log(date, format, from_time_zone, to_time_zone, "fsldkjafklahskjdh");
  //   var moment = require("moment-timezone");
  let formated_date = moment(date, "YYYY-MM-DD HH:mm:ss").format(
    "YYYY-MM-DD HH:mm"
  );
  let momentObj = moment.tz(
    formated_date,
    "YYYY-MM-DD HH:mm:ss",
    from_time_zone
  );

  let final_date = moment(momentObj).tz(to_time_zone).format(format);
  return final_date;
};



export const convertTimeToServerTimeZone = (time, fromTZ="UTC", toTZ) => {
  if (!time || !fromTZ || !toTZ) return null;

  // Fix timezone format ("Asia?karachi" → "Asia/Karachi")
  const safeFrom = fromTZ.replace(/[^A-Za-z/_]/g, "/");
  const safeTo = toTZ.replace(/[^A-Za-z/_]/g, "/");

  // Combine today's date with the provided time
  const today = dayjs().format("YYYY-MM-DD");
  const fullDateTime = `${today} ${time}`; // e.g. "2025-11-25 16:00"

  return dayjs.tz(fullDateTime, safeFrom).tz(safeTo).format("HH:mm");
};


export const urlPatternValidation = (URL) => {
  const regex = new RegExp(
    "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?"
  );
  return regex.test(URL);
};
export const dummyPost = {
  userAvatar: "https://via.placeholder.com/50", // Replace with actual user image
  username: "Alvin Elian",
  role: "Managing Director",
  company: "Philosophy Science LLC",
  timeAgo: "3 hrs",
  content:
    "A Managing Director at Philosophy Science LLC oversees strategic planning, operations, and team leadership, ensuring the organization excels in its philosophical and scientific pursuits while driving growth and innovation.",
  image: "https://via.placeholder.com/600x300", // Replace with actual post image
  likes: "1134",
  comments: "49",
};
export const breadcrumbMap = {
  "/warehouse": "Warehouse & Logistics",
  "/hospitality": "Hospitality",
  "/healthcare": "HealthCare",
  "/office-source": "Office Source",
  "/retail-source": "Retail Source",
  "/food-source": "Food Source",
  "/fitOur-source": "fitOur Source",
};
export const path = "/hospitality/partners/affilation-partners";
export const pathRecruitment = "/hospitality/partners/recruitment-partners";
export const pathRecDetail =
  "/hospitality/partners/recruitment-partners/recruitment-detail";
export const affilationPath =
  "/hospitality/partners/affilation-partners/affilation-detail";
export const profilepath = "/profile";
export const interViewDetailPath = "/hospitality/interview/interview-detail";
export const wareHouseDetailPath =
  "/warehouse/interview/interview-blog-list/interview-detai";
export const HealthcareDetailPath =
  "/healthcare/interview/interview-blog-list/interview-detai";

export const interViewBlogListPath =
  "/hospitality/interview/interview-blog-list";
export const officesourceinterdetail =
  "/office-source/interview/interview-blog-list/interview-detail";
export const retailinterviewDetail =
  "/retail-source/interview/interview-blog-list/interview-detail";
export const FoodSourceInterViewDetail =
  "/food-source/interview/interview-blog-list/interview-detail";
export const constructionInterViewDetail =
  "/construction-source/interview/interview-blog-list/interview-detail";
export const FitOutDetailInterView =
  "/fit-out-source/interview/interview-blog-list/interview-detail";

export const topicsInterview = [
  {
    id: 1,
    logo: inter1,
    title: "Interview Preparation ",
    content: "Content for Interview Preparation",
    blogIntroduction:
      "Preparing for an interview is crucial to making a great first impression and increasing your chances of success. " +
      "A well-prepared candidate demonstrates confidence, professionalism, and enthusiasm for the role. " +
      "Interviews are not just about answering questions correctly but also about presenting yourself as the best fit for the company culture. " +
      "With proper research, practice, and strategy, you can significantly improve your chances of securing your dream job. " +
      "This guide will walk you through essential preparation steps to help you succeed in any interview scenario.",
    BlogList: [
      {
        id: 1,
        title: "Top 10 Common Interview Questions and How to Answer Them",
        description:
          "A deep dive into frequently asked interview questions and effective response strategies.",
        blogIntroduction:
          "Understanding the most common interview questions and how to answer them effectively can help you stand out. This blog provides a strategic approach to answering them confidently.",
        tip: "Use the STAR method (Situation, Task, Action, Result) to structure your answers clearly and effectively.",
        steps: [
          "Understand why employers ask these questions.",
          "Prepare answers using the STAR method.",
          "Practice concise and confident responses.",
          "Tailor answers to the job role and company culture.",
          "Avoid generic responses; personalize with real experiences.",
          "Prepare for unexpected follow-up questions.",
          "Work on tone and body language while answering.",
          "Rehearse mock interviews with a friend or mentor.",
          "Stay honest and professional in your responses.",
          "End with a strong, positive closing statement.",
        ],
      },
      {
        id: 2,
        title: "Body Language Tips for a Confident and Professional Interview",
        description:
          "The importance of non-verbal communication and how to use body language to make a great impression.",
        blogIntroduction:
          "Your body language speaks volumes in an interview. Understanding how to use it to your advantage can boost your confidence and make a lasting impression.",
        tip: "Maintain eye contact and good posture to project confidence and engagement.",
        steps: [
          "Maintain good posture and sit up straight.",
          "Make natural and confident eye contact.",
          "Use hand gestures subtly to emphasize key points.",
          "Avoid fidgeting, crossing arms, or slouching.",
          "Smile genuinely to appear friendly and approachable.",
          "Mirror the interviewer’s energy and engagement.",
          "Use a firm handshake (or a polite nod in virtual interviews).",
          "Control nervous habits like tapping or leg shaking.",
          "Speak with a steady, confident tone.",
          "Practice body language techniques in front of a mirror.",
        ],
      },
      {
        id: 3,
        title: "How to Research a Company Before Your Interview",
        description:
          "A guide on gathering relevant company insights to demonstrate interest and alignment with company values.",
        blogIntroduction:
          "Proper research about a company before an interview shows that you are serious about the role and helps you tailor your responses to align with their values.",
        tip: "Use multiple sources like the company website, LinkedIn, and industry news to gather insights.",
        steps: [
          "Visit the company’s official website to understand their mission and values.",
          "Read recent company news, press releases, and industry trends.",
          "Check employee reviews on platforms like Glassdoor.",
          "Explore the company’s social media profiles for culture insights.",
          "Analyze job descriptions to understand key responsibilities.",
          "Look at LinkedIn profiles of employees and leadership.",
          "Research competitors to understand the industry landscape.",
          "Prepare talking points based on company achievements.",
          "Find out about any recent projects, funding, or partnerships.",
          "Formulate thoughtful questions to show your research efforts.",
        ],
      },
      {
        id: 4,
        title: "The Art of Asking Questions: What to Ask Your Interviewer",
        description:
          "Essential questions to ask at the end of an interview to leave a lasting impact.",
        blogIntroduction:
          "Interviews are a two-way street. Asking thoughtful questions not only shows your interest but also helps you determine if the company is the right fit for you.",
        tip: "Ask about company culture, team dynamics, and career growth to show genuine interest.",
        steps: [
          "Understand why asking questions is important.",
          "Avoid generic questions—ask about company culture and growth.",
          "Inquire about challenges the team is facing.",
          "Ask about professional development and learning opportunities.",
          "Clarify expectations for the role within the first six months.",
          "Request insights on team structure and collaboration.",
          "Discuss how success is measured in the role.",
          "Ask about the company’s future goals and plans.",
          "Show enthusiasm by asking about next steps in the hiring process.",
          "End with a question that demonstrates genuine interest in the company.",
        ],
      },
      {
        id: 5,
        title:
          "How to Ace Virtual Interviews: Best Practices & Common Mistakes to Avoid",
        description:
          "A step-by-step guide on excelling in online interviews, including tech setup, etiquette, and engagement tips.",
        blogIntroduction:
          "With the rise of remote work, virtual interviews have become common. Knowing how to navigate them effectively can give you a competitive edge.",
        tip: "Test your internet, camera, and microphone in advance to avoid technical issues during the interview.",
        steps: [
          "Test your internet connection and video/audio settings in advance.",
          "Choose a quiet, well-lit environment with a clean background.",
          "Dress professionally, just like an in-person interview.",
          "Make eye contact by looking into the camera.",
          "Eliminate distractions and silence notifications.",
          "Speak clearly and at a moderate pace.",
          "Use body language to stay engaged and confident.",
          "Have a copy of your resume and notes nearby.",
          "Be prepared for potential technical issues with a backup plan.",
          "Follow up with a thank-you email after the interview.",
        ],
      },
      {
        id: 6,
        title:
          "Interview Follow-Up: The Importance of Thank-You Emails & How to Write One",
        description:
          "A breakdown of why and how to send a compelling thank-you email to reinforce your candidacy.",
        blogIntroduction:
          "Following up after an interview shows professionalism and reinforces your enthusiasm for the position. A well-crafted thank-you email can set you apart from other candidates.",
        tip: "Mention specific points from your interview to make your thank-you email more personalized and memorable.",
        steps: [
          "Send a thank-you email within 24 hours of the interview.",
          "Personalize your message by mentioning key discussion points.",
          "Express gratitude for the opportunity and the interviewer’s time.",
          "Reiterate your enthusiasm for the role and company.",
          "Highlight one or two relevant skills discussed during the interview.",
          "Address any concerns or additional points that may strengthen your application.",
          "Keep the email concise and professional.",
          "Use a clear subject line like 'Thank You for the Opportunity'.",
          "Check for grammar and spelling errors before sending.",
          "End with a polite closing, such as 'Looking forward to your response'.",
        ],
      },
    ],
    KeyPreparationSteps: [
      "Research the Company: Understand its values, mission, and recent achievements.",
      "Understand the Role: Analyze the job description and match your skills accordingly.",
      "Practice Common Questions: Prepare answers to standard and role-specific questions.",
      "Prepare Your Resume: Ensure it is up-to-date and highlights your achievements.",
      "Plan Logistics: Know the interview format (online/in-person) and arrive on time.",
      "Learn About the Interviewers: Check their LinkedIn profiles or company bio if available.",
      "Prepare Questions for the Interviewer: Show curiosity about the role and company growth.",
      "Improve Your Speaking Skills: Practice speaking clearly and confidently in front of a mirror or with a friend.",
      "Dress for Success: Choose professional attire that aligns with the company's dress code.",
      "Stay Updated on Industry Trends: Being aware of the latest industry developments shows expertise and passion.",
      "Mock Interviews: Conduct mock sessions with friends, mentors, or AI tools to refine your responses.",
      "Mindset and Stress Management: Meditate, exercise, or practice breathing techniques to stay calm and focused.",
      "Prepare Your Digital Setup: If the interview is virtual, ensure your camera, microphone, and internet connection work properly.",
      "Have a Backup Plan: Prepare alternative communication methods in case of technical difficulties.",
      "Take Notes: Bring a notebook to jot down important discussion points during the interview.",
    ],

    FinalTip:
      "Confidence comes from preparation. Rehearse, stay calm, and be professional. " +
      "Remember, an interview is not just about getting hired—it's also an opportunity for you to assess if the company aligns with your values and career aspirations. " +
      "Approach the conversation as a two-way discussion rather than an interrogation. " +
      "Maintain positive body language, listen actively, and engage with the interviewer to create a lasting impression. " +
      "Lastly, always follow up with a thank-you email to express gratitude and reinforce your interest in the role.",
  },
  {
    id: 2,
    title: "Presentation for Interview",
    content: "Content for Presentation for Interview",
    logo: inter2,
    BlogList: [
      {
        id: 1,
        title: "How to Structure an Effective Interview Presentation",
        description:
          "A step-by-step guide on organizing your content for a clear and impactful presentation.",
        blogIntroduction:
          "A well-structured presentation helps you deliver your message with clarity and confidence. Understanding how to organize your content ensures a strong and engaging delivery.",
        tip: "Start with a strong opening, keep your main points concise, and conclude with a memorable summary.",
        steps: [
          "Begin with a compelling introduction to grab attention.",
          "Clearly outline your key points in a logical order.",
          "Use bullet points or structured sections to maintain clarity.",
          "Incorporate relevant examples or data to support your arguments.",
          "Keep each section focused and avoid overwhelming with too much information.",
          "Practice transitions to ensure a smooth flow between sections.",
          "Summarize key takeaways at the end to reinforce your message.",
          "End with a strong closing statement and call to action.",
        ],
      },
      {
        id: 2,
        title: "Top 5 Presentation Mistakes to Avoid During an Interview",
        description:
          "Common pitfalls candidates face and how to prevent them for a flawless presentation.",
        blogIntroduction:
          "Even the most well-prepared candidates can make presentation mistakes that undermine their impact. Knowing what to avoid can help you deliver a polished and confident performance.",
        tip: "Avoid reading directly from slides, overloading them with text, or speaking too fast.",
        steps: [
          "Don’t overload slides with too much text – keep them visual and concise.",
          "Avoid reading directly from slides; engage with the audience instead.",
          "Maintain a steady speaking pace and avoid rushing.",
          "Ensure your body language and facial expressions convey confidence.",
          "Test your technology and setup to prevent last-minute issues.",
        ],
      },
      {
        id: 3,
        title: "The Power of Storytelling in Interview Presentations",
        description:
          "How to use storytelling techniques to engage and connect with your audience.",
        blogIntroduction:
          "Storytelling is a powerful tool that helps make your presentation more engaging and memorable. Learning how to craft compelling narratives can set you apart.",
        tip: "Use real-life examples and personal experiences to make your points more relatable and impactful.",
        steps: [
          "Start with a personal anecdote or real-world example.",
          "Use a clear beginning, middle, and end structure.",
          "Incorporate emotions to make your story more engaging.",
          "Relate the story back to the main message of your presentation.",
          "Practice delivering your story naturally and confidently.",
        ],
      },
      {
        id: 4,
        title: "Virtual Interview Presentations: Tips for Success",
        description:
          "Best practices for delivering a compelling presentation in an online interview setting.",
        blogIntroduction:
          "Virtual interviews require a unique approach to ensure your presentation remains engaging despite the digital barrier. Mastering online presentation techniques can give you a competitive edge.",
        tip: "Test your internet, lighting, and background before the interview to ensure a professional setup.",
        steps: [
          "Check your internet connection, camera, and microphone before starting.",
          "Ensure proper lighting and a clutter-free background.",
          "Dress professionally to create a strong impression.",
          "Look at the camera to maintain eye contact with the interviewer.",
          "Use gestures and facial expressions to keep your presentation engaging.",
          "Eliminate distractions and silence notifications before starting.",
          "Keep your slides simple and visually appealing for virtual viewing.",
        ],
      },
      {
        id: 5,
        title: "How to Handle Q&A Sessions with Confidence",
        description:
          "Techniques to prepare for and respond to tough questions during your presentation.",
        blogIntroduction:
          "Handling Q&A sessions effectively can demonstrate your expertise and ability to think on your feet. Learning how to navigate tough questions is essential for a strong interview performance.",
        tip: "Listen carefully, take a moment before responding, and structure your answers concisely.",
        steps: [
          "Anticipate potential questions and prepare responses in advance.",
          "Listen carefully to the question before answering.",
          "Use the STAR (Situation, Task, Action, Result) method when applicable.",
          "Stay calm and confident, even if caught off guard.",
          "Clarify the question if needed before responding.",
          "Provide structured and concise answers to maintain engagement.",
        ],
      },
      {
        id: 6,
        title: "Designing Slides That Impress: Less Text, More Impact",
        description:
          "How to create visually appealing and effective slides that enhance your presentation.",
        blogIntroduction:
          "Your slides should complement your speech, not overshadow it. Learning to design visually appealing slides can help you create a powerful and engaging presentation.",
        tip: "Use simple visuals, limit text to key points, and maintain a consistent design theme.",
        steps: [
          "Use a clean and professional slide template.",
          "Limit text on slides—keep key points concise.",
          "Use high-quality images and graphics to illustrate concepts.",
          "Maintain a consistent color scheme and font style.",
          "Avoid excessive animations or distracting effects.",
          "Ensure your slides are easy to read and well-formatted.",
        ],
      },
    ],
    blogIntroduction:
      "A strong presentation during an interview can set you apart from other candidates. " +
      "Whether you are required to give a formal presentation or simply want to present yourself confidently, " +
      "your communication, clarity, and organization play a critical role in leaving a positive impression. " +
      "This guide will help you develop an impactful presentation strategy.",

    KeyPreparationSteps: [
      "Understand the Objective: Know what the interviewer expects from your presentation.",
      "Structure Your Content: Use a clear and logical format, such as Introduction, Key Points, and Conclusion.",
      "Create Engaging Slides: Use minimal text, visuals, and a clean design to keep your audience engaged.",
      "Practice Your Delivery: Rehearse multiple times to improve confidence and fluency.",
      "Control Your Pace: Speak clearly, avoid rushing, and use pauses effectively.",
      "Use Confident Body Language: Maintain eye contact, stand tall, and use gestures naturally.",
      "Handle Questions Gracefully: Prepare for potential questions and answer with confidence.",
      "Use Storytelling: Connect with your audience by using relevant stories and examples.",
      "Test Your Technology: If presenting virtually, check your slides, internet connection, and microphone in advance.",
      "Stay Calm and Collected: Take deep breaths, smile, and remain composed even if something goes off track.",
    ],

    FinalTip:
      "A well-structured and confident presentation can showcase not just your knowledge but also your ability to communicate effectively. " +
      "Remember to tailor your message to the audience, use a clear and engaging style, and practice until you feel confident. " +
      "Whether it’s a formal PowerPoint presentation or simply how you present yourself, preparation is key to making a lasting impression.",
  },
  {
    id: 3,
    title: "Dress Code",
    content: "Content for Dress Code",
    logo: inter3,
    BlogList: [
      {
        id: 1,
        title: "How to Dress for Different Types of Interviews",
        description:
          "A breakdown of dress codes for corporate, startup, and creative industry interviews.",
        blogIntroduction:
          "Your outfit should align with the company's culture and industry expectations. Choosing the right attire can set the tone for a positive first impression.",
        tip: "Research the company's dress code beforehand to ensure your outfit aligns with its culture.",
        steps: [
          "Corporate Interviews: Stick to formal business attire (suit, tie, dress, or blazer).",
          "Startup Interviews: Opt for smart casual or business casual, depending on the company's environment.",
          "Creative Industry Interviews: Showcase personality with stylish yet professional attire.",
          "Tech Industry Interviews: A polished but relaxed business casual look works best.",
          "Always choose clean, well-fitted clothing to maintain a professional appearance.",
        ],
      },
      {
        id: 2,
        title: "Business Formal vs. Business Casual: What’s the Difference?",
        description:
          "A guide to understanding and choosing the right dress code for your interview.",
        blogIntroduction:
          "Not all professional attire is the same. Understanding the difference between business formal and business casual can help you dress appropriately for any interview.",
        tip: "If unsure, opt for business formal—it’s better to be slightly overdressed than underdressed.",
        steps: [
          "Business Formal: Traditional suits, button-down shirts, ties, and polished shoes.",
          "Business Casual: Dress pants or chinos, collared shirts, blouses, and professional shoes.",
          "Avoid overly casual elements like sneakers, t-shirts, or ripped jeans.",
          "When in doubt, observe how employees dress or ask HR about the dress code.",
        ],
      },
      {
        id: 3,
        title: "Top 10 Interview Attire Mistakes to Avoid",
        description:
          "Common fashion faux pas candidates make and how to avoid them.",
        blogIntroduction:
          "Your outfit can speak volumes about your professionalism. Avoid these common mistakes to ensure a polished and confident look.",
        tip: "Always try on your outfit a day before the interview to check for any last-minute issues.",
        steps: [
          "Wearing wrinkled or stained clothing.",
          "Choosing overly flashy or distracting outfits.",
          "Wearing inappropriate footwear (e.g., sneakers or flip-flops).",
          "Ignoring the company culture while selecting attire.",
          "Overusing strong perfume or cologne.",
          "Not grooming properly (unkempt hair, untrimmed nails, etc.).",
          "Wearing excessive accessories or jewelry.",
          "Wearing uncomfortable clothing that affects confidence.",
          "Not testing your outfit for comfort while sitting and standing.",
          "Ignoring proper hygiene and breath freshness.",
        ],
      },
      {
        id: 4,
        title: "Virtual Interview Attire: How to Look Professional on Camera",
        description:
          "Tips on dressing appropriately for online interviews, including lighting and background considerations.",
        blogIntroduction:
          "Virtual interviews require the same level of professionalism as in-person meetings. Dressing appropriately on camera can enhance your presence and confidence.",
        tip: "Wear solid colors instead of patterns to avoid distractions on camera.",
        steps: [
          "Choose solid, neutral, or muted colors for a clean, professional look.",
          "Avoid overly bright or patterned outfits that may look distracting on screen.",
          "Ensure your clothing is well-fitted and ironed for a polished appearance.",
          "Sit in a well-lit area with a clean, neutral background.",
          "Avoid wearing casual attire from the waist down in case you need to stand up.",
        ],
      },
      {
        id: 5,
        title: "How Grooming and Personal Hygiene Impact Your Interview",
        description:
          "The importance of grooming, from hairstyles to subtle fragrance choices.",
        blogIntroduction:
          "Grooming and hygiene are just as important as your outfit. Small details can leave a lasting impression on the interviewer.",
        tip: "Keep your look neat, fresh, and professional—good grooming shows attention to detail.",
        steps: [
          "Maintain a clean and well-groomed hairstyle.",
          "Trim facial hair or keep it neatly styled if applicable.",
          "Ensure fresh breath and avoid strong-smelling foods before the interview.",
          "Keep nails clean and well-maintained.",
          "Use subtle fragrances and avoid overpowering scents.",
        ],
      },
      {
        id: 6,
        title:
          "Dressing with Confidence: The Psychology of Professional Attire",
        description:
          "How the right outfit can boost your confidence and help you make a lasting impression.",
        blogIntroduction:
          "What you wear can influence how you feel and how others perceive you. Dressing confidently can enhance your overall interview performance.",
        tip: "Wear clothing that makes you feel empowered and comfortable—it will boost your confidence.",
        steps: [
          "Choose an outfit that makes you feel strong and capable.",
          "Stand tall and maintain good posture to exude confidence.",
          "Avoid fidgeting with your clothing or accessories.",
          "Make sure your clothing fits well and is comfortable.",
          "Smile and project a positive, self-assured demeanor.",
        ],
      },
    ],
    blogIntroduction:
      "Dressing appropriately for an interview is a key aspect of making a strong first impression. " +
      "Your attire reflects your professionalism, attention to detail, and understanding of company culture. " +
      "Different industries have different expectations, so it’s essential to research the company dress code in advance. " +
      "This guide will help you choose the right outfit to ensure you look confident and polished on interview day.",

    KeyPreparationSteps: [
      "Know the Company Culture: Research whether the company has a formal, business casual, or relaxed dress code.",
      "Stick to Neutral Colors: Opt for classic colors like black, navy, gray, or white to keep your look professional.",
      "Ensure a Proper Fit: Well-fitted clothing looks polished and gives a confident appearance.",
      "Keep Accessories Minimal: Simple jewelry, a professional watch, and minimal makeup create a clean look.",
      "Polish Your Shoes: Make sure your footwear is clean and appropriate for the setting.",
      "Maintain Good Grooming: Neatly styled hair, trimmed nails, and fresh breath add to a professional look.",
      "Avoid Strong Fragrances: Keep perfumes or colognes subtle to avoid overwhelming the interviewer.",
      "Prepare the Night Before: Lay out your outfit in advance to avoid last-minute stress.",
      "Dress for Virtual Interviews: Even for online interviews, wear professional attire to stay in the right mindset.",
      "Confidence is Key: Whatever you wear, carry yourself with confidence and professionalism.",
    ],

    FinalTip:
      "Dressing appropriately is not just about the clothes; it's about the impression you leave. " +
      "A professional appearance shows that you respect the opportunity and are serious about the role. " +
      "When in doubt, it's always better to be slightly overdressed than underdressed. " +
      "Remember, confidence, a smile, and positive body language are just as important as what you wear!",
  },
  {
    id: 4,
    logo: inter4,
    title: "Interview Questions",
    content: "Content for Interview Questions",
    BlogList: [
      {
        id: 1,
        title: "Top 10 Most Common Interview Questions and How to Answer Them",
        description:
          "A guide to handling frequently asked interview questions with confidence.",
        blogIntroduction:
          "Interviewers often ask common questions to assess your skills, experience, and personality. Being well-prepared can set you apart from other candidates.",
        tip: "Use real-life examples and keep your answers concise yet impactful.",
        steps: [
          "Research the most frequently asked interview questions.",
          "Understand what the interviewer wants to learn from each question.",
          "Structure your answers using the STAR method (Situation, Task, Action, Result).",
          "Practice giving clear and confident responses.",
          "Tailor your answers to align with the company’s needs and values.",
        ],
      },
      {
        id: 2,
        title: "How to Use the STAR Method for Behavioral Interview Questions",
        description:
          "A step-by-step breakdown of the STAR method and how to apply it effectively.",
        blogIntroduction:
          "The STAR method is a powerful technique for answering behavioral interview questions by providing structured and compelling responses.",
        tip: "Keep your responses structured and to the point—avoid unnecessary details.",
        steps: [
          "Identify the key behavioral questions commonly asked in interviews.",
          "Understand the STAR framework: Situation, Task, Action, Result.",
          "Choose real experiences that best showcase your skills and abilities.",
          "Practice framing your responses using the STAR technique.",
          "Ensure that each story highlights your contributions and positive outcomes.",
        ],
      },
      {
        id: 3,
        title: "Handling Tough Interview Questions: Strategies for Success",
        description:
          "Learn how to tackle tricky questions about weaknesses, gaps in employment, and career changes.",
        blogIntroduction:
          "Challenging questions are designed to test your ability to think critically and handle pressure. A well-prepared response can turn a tricky question into an opportunity.",
        tip: "Stay honest, but always frame your answers in a positive and proactive way.",
        steps: [
          "Anticipate tough questions related to weaknesses, gaps, or career changes.",
          "Prepare responses that focus on growth, learning, and improvement.",
          "Use the 'problem-solution-benefit' approach to turn negatives into positives.",
          "Stay calm and composed—avoid defensive or overly apologetic tones.",
          "Practice your answers to sound natural and confident.",
        ],
      },
      {
        id: 4,
        title:
          "Technical Interview Questions: Tips for Acing Role-Specific Questions",
        description:
          "Advice on preparing for technical interviews and demonstrating expertise in your field.",
        blogIntroduction:
          "Technical interviews evaluate your problem-solving skills, technical knowledge, and ability to apply concepts in real-world scenarios.",
        tip: "Practice solving technical problems out loud to demonstrate your thought process.",
        steps: [
          "Review key technical concepts and industry-specific knowledge.",
          "Practice coding or problem-solving under time constraints (for tech roles).",
          "Understand the job’s required technical skills and focus on them.",
          "Prepare for scenario-based or case study questions related to your field.",
          "Explain your thought process clearly to showcase logical thinking.",
        ],
      },
      {
        id: 5,
        title: "The Best Questions to Ask Your Interviewer",
        description:
          "A list of smart, insightful questions to ask that show curiosity and engagement.",
        blogIntroduction:
          "Asking thoughtful questions demonstrates your enthusiasm for the role and helps you assess whether the company is the right fit for you.",
        tip: "Avoid yes/no questions—ask open-ended ones to encourage discussion.",
        steps: [
          "Prepare questions that reflect genuine interest in the company and role.",
          "Ask about company culture, team dynamics, and growth opportunities.",
          "Inquire about the expectations for the first few months in the role.",
          "Seek insights on current challenges and future goals of the company.",
          "End with a question about the next steps in the hiring process.",
        ],
      },
      {
        id: 6,
        title:
          "Mock Interviews: Why Practicing with a Friend or AI Can Boost Confidence",
        description:
          "How simulated interviews can improve fluency, reduce anxiety, and refine your responses.",
        blogIntroduction:
          "Practicing through mock interviews can help reduce nervousness and improve your ability to respond effectively under pressure.",
        tip: "Record yourself during a mock interview to analyze and improve your performance.",
        steps: [
          "Set up mock interviews with a friend, mentor, or AI-based platform.",
          "Use real interview questions relevant to your industry.",
          "Practice maintaining good posture, eye contact, and a confident tone.",
          "Analyze your answers and refine them for clarity and impact.",
          "Incorporate feedback to enhance your responses and overall performance.",
        ],
      },
    ],
    blogIntroduction:
      "Being prepared for interview questions can make a significant difference in how confidently and effectively you respond. " +
      "Hiring managers ask various types of questions to assess your skills, experience, personality, and problem-solving ability. " +
      "While some questions are standard, others are tailored to the specific role or industry. " +
      "This guide will cover the most common interview questions and how to answer them effectively.",

    KeyPreparationSteps: [
      "Research Common Interview Questions: Familiarize yourself with frequently asked questions in your industry.",
      "Understand the Job Description: Tailor your answers to align with the skills and requirements listed in the job post.",
      "Prepare STAR Responses: Use the STAR method (Situation, Task, Action, Result) to structure answers for behavioral questions.",
      "Practice Out Loud: Rehearse your answers in front of a mirror or with a friend to improve fluency and confidence.",
      "Prepare Examples: Think of real-life work situations that highlight your problem-solving, leadership, and teamwork skills.",
      "Study the Company: Research the company’s values, culture, and recent projects to demonstrate knowledge and enthusiasm.",
      "Stay Updated on Industry Trends: Be aware of current developments in your field to answer technical or industry-related questions.",
      "Develop a Strategy for Tough Questions: Plan responses for gaps in employment, career changes, or weaknesses.",
      "Ask Thoughtful Questions: Prepare intelligent questions about the role, team, or company to show genuine interest.",
      "Stay Calm and Collected: Manage interview anxiety through deep breathing and positive visualization.",
    ],

    FinalTip:
      "The key to answering interview questions effectively is preparation and confidence. " +
      "Use the STAR method (Situation, Task, Action, Result) for behavioral questions to provide structured responses. " +
      "For technical questions, demonstrate both your knowledge and problem-solving approach. " +
      "Most importantly, be honest and authentic in your answers. " +
      "Practicing with a friend or mentor can boost your confidence and help you refine your responses.",
  },
  {
    id: 5,
    title: "Successful Interview Process",
    logo: inter5,
    content: "Content for Successful Interview Process",
    BlogList: [
      {
        id: 1,
        title:
          "The Ultimate Interview Checklist: What to Do Before, During, and After",
        description:
          "A step-by-step guide to ensure you're fully prepared and confident for your interview.",
        blogIntroduction:
          "Preparation is the key to a successful interview. This checklist covers everything you need to do before, during, and after your interview.",
        tip: "Stay organized—create a checklist to track your interview preparation.",
        steps: [
          "Research the company, job role, and interviewer.",
          "Prepare responses to common interview questions.",
          "Choose professional attire that fits the company culture.",
          "Plan your route and arrive at least 10 minutes early.",
          "Maintain good posture, eye contact, and confident body language.",
          "Take notes during the interview to reference later.",
          "Ask insightful questions about the company and role.",
          "Send a thank-you email within 24 hours.",
          "Reflect on your performance and areas for improvement.",
        ],
      },
      {
        id: 2,
        title: "How to Make a Great First Impression in an Interview",
        description:
          "Tips on body language, tone, and approach to create a strong and lasting impression.",
        blogIntroduction:
          "First impressions matter! Making a positive impact in the first few minutes of an interview sets the tone for the rest of the conversation.",
        tip: "Confidence is key—walk in with a smile and a firm handshake.",
        steps: [
          "Dress appropriately and groom yourself neatly.",
          "Greet the interviewer with a confident handshake and a smile.",
          "Make eye contact and use positive body language.",
          "Introduce yourself in a clear and professional manner.",
          "Show enthusiasm and energy from the start.",
          "Listen attentively and engage actively in the conversation.",
        ],
      },
      {
        id: 3,
        title: "Common Interview Mistakes and How to Avoid Them",
        description:
          "A list of common interview pitfalls and expert tips to steer clear of them.",
        blogIntroduction:
          "Even the best candidates make mistakes. Being aware of common pitfalls can help you avoid them and make a strong impression.",
        tip: "Preparation is the best way to prevent common mistakes.",
        steps: [
          "Avoid arriving late—plan your commute ahead of time.",
          "Don’t speak negatively about past employers or jobs.",
          "Keep answers concise—avoid rambling.",
          "Maintain good posture and eye contact; avoid nervous habits.",
          "Research the company beforehand to show genuine interest.",
          "Ask thoughtful questions instead of saying you have none.",
          "Follow up after the interview with a thank-you email.",
        ],
      },
      {
        id: 4,
        title:
          "How to Follow Up After an Interview: Thank-You Emails & Next Steps",
        description:
          "Learn the best ways to follow up with the interviewer and reinforce your interest in the role.",
        blogIntroduction:
          "Following up after an interview shows professionalism and keeps you on the interviewer’s radar.",
        tip: "Send a thank-you email within 24 hours to express appreciation.",
        steps: [
          "Thank the interviewer for their time and insights.",
          "Mention key discussion points to reinforce your interest.",
          "Reiterate your enthusiasm for the position.",
          "Address any unanswered questions from the interview.",
          "Keep the email concise and professional.",
          "Politely inquire about the next steps in the hiring process.",
        ],
      },
      {
        id: 5,
        title: "Interview Etiquette: Do’s and Don’ts for a Successful Meeting",
        description:
          "Professional etiquette rules that can help you stand out and make a great impression.",
        blogIntroduction:
          "Good interview etiquette reflects professionalism and respect. Mastering these do’s and don’ts can boost your chances of success.",
        tip: "Respect everyone you meet, from the receptionist to the interviewer.",
        steps: [
          "Do dress appropriately for the company culture.",
          "Do listen attentively and avoid interrupting.",
          "Do maintain eye contact and positive body language.",
          "Don’t use slang or overly casual language.",
          "Don’t check your phone or watch during the interview.",
          "Don’t badmouth past employers or colleagues.",
        ],
      },
      {
        id: 6,
        title: "How to Stay Confident and Overcome Interview Anxiety",
        description:
          "Effective strategies for managing nerves and staying composed during interviews.",
        blogIntroduction:
          "Feeling nervous before an interview is normal, but confidence can be built with the right strategies.",
        tip: "Practice deep breathing before the interview to stay calm.",
        steps: [
          "Prepare thoroughly to boost your confidence.",
          "Practice mock interviews with a friend or mentor.",
          "Use positive affirmations to reinforce self-belief.",
          "Take deep breaths before and during the interview.",
          "Focus on the conversation instead of overanalyzing.",
          "Remember that the interviewer wants you to succeed!",
        ],
      },
    ],
    blogIntroduction:
      "A successful interview process is not just about answering questions correctly—it’s about making a great impression, " +
      "demonstrating your value to the company, and effectively communicating your skills and experience. " +
      "From preparation to follow-up, each step in the interview process plays a crucial role in securing the job offer. " +
      "This guide outlines the key steps to ensure you ace your interview and stand out as the ideal candidate.",

    KeyPreparationSteps: [
      "Thorough Preparation: Research the company, understand the job role, and prepare for common and role-specific questions.",
      "Professional Appearance: Dress appropriately based on the company culture and industry expectations.",
      "Confidence & Body Language: Maintain good posture, make eye contact, and use positive body language to show confidence.",
      "Clear & Concise Responses: Answer questions directly and use the STAR method (Situation, Task, Action, Result) for structured responses.",
      "Engage with the Interviewer: Build rapport by listening actively and responding thoughtfully to questions.",
      "Showcase Your Skills: Highlight your experience with real-life examples that align with the job requirements.",
      "Ask Insightful Questions: Demonstrate interest by asking about company culture, team dynamics, and growth opportunities.",
      "Manage Nerves Effectively: Practice deep breathing and visualization techniques to stay calm and focused.",
      "Follow Up Professionally: Send a thank-you email within 24 hours, expressing appreciation and reiterating your interest.",
      "Reflect & Improve: Review your performance post-interview and identify areas for improvement for future opportunities.",
    ],

    FinalTip:
      "A successful interview process is more than just answering questions—it’s about making a lasting impression. " +
      "Approach the interview with confidence, be authentic, and show enthusiasm for the role. " +
      "Even if you don’t get the job, treat every interview as a learning experience and use feedback to improve. " +
      "Remember, preparation and a positive attitude can set you apart from other candidates.",
  },
  {
    id: 6,
    title: "Interview Feedback",
    content: "Content for Interview Feedback",
    logo: inter6,
    BlogList: [
      {
        id: 1,
        title: "How to Ask for Interview Feedback (With Email Templates)",
        description:
          "Learn how to request feedback professionally to improve your future performance.",
        blogIntroduction:
          "Constructive feedback helps you refine your approach and improve for future interviews. Knowing how to request it politely can increase your chances of receiving useful insights.",
        tip: "Send your feedback request within a few days of receiving a rejection or decision.",
        steps: [
          "Wait at least 24-48 hours after receiving the interview outcome before requesting feedback.",
          "Be polite and express gratitude for the opportunity.",
          "Keep your request brief and professional.",
          "Ask for specific areas where you could improve.",
          "Use email templates for a structured request.",
          "Be open to feedback and avoid being defensive.",
        ],
      },
      {
        id: 2,
        title:
          "Understanding Constructive Criticism: Turning Feedback into Growth",
        description:
          "Discover ways to handle criticism positively and use it for self-improvement.",
        blogIntroduction:
          "Receiving critical feedback can be tough, but it’s a valuable tool for growth. Learning to process and apply feedback effectively can make you a stronger candidate.",
        tip: "View feedback as an opportunity, not a setback.",
        steps: [
          "Listen actively without interrupting or defending yourself.",
          "Take notes to process the feedback later.",
          "Ask follow-up questions if clarification is needed.",
          "Identify patterns in feedback from different interviews.",
          "Use feedback to develop an improvement plan.",
          "Stay positive and focus on growth rather than mistakes.",
        ],
      },
      {
        id: 3,
        title: "Top Reasons Candidates Get Rejected (And How to Fix Them)",
        description:
          "A breakdown of common rejection reasons and strategies to avoid them.",
        blogIntroduction:
          "Rejections happen for various reasons, but identifying and addressing these issues can improve your chances in the next interview.",
        tip: "Self-reflection is key—analyze past interviews to spot areas for improvement.",
        steps: [
          "Lack of preparation—research the company and practice responses.",
          "Weak communication skills—work on clarity, confidence, and articulation.",
          "Not aligning with company culture—understand the company’s values.",
          "Failure to demonstrate relevant skills—highlight achievements with examples.",
          "Negative body language—maintain eye contact and confidence.",
          "No follow-up—always send a thank-you email post-interview.",
        ],
      },
      {
        id: 4,
        title: "How to Give Effective Interview Feedback as a Hiring Manager",
        description:
          "Best practices for providing constructive and meaningful feedback to candidates.",
        blogIntroduction:
          "Providing thoughtful feedback to candidates helps them grow and reflects positively on your company’s hiring process.",
        tip: "Be specific and focus on both strengths and areas for improvement.",
        steps: [
          "Start with positive aspects of the candidate’s performance.",
          "Provide constructive criticism with specific examples.",
          "Offer actionable suggestions for improvement.",
          "Keep feedback objective and focused on the job role.",
          "Avoid personal judgments—focus on skills and experience.",
          "Encourage candidates to apply for future opportunities if suitable.",
        ],
      },
      {
        id: 5,
        title: "Why You Didn’t Get the Job: Decoding Interview Feedback",
        description:
          "Interpreting recruiter feedback and using it to refine your interview approach.",
        blogIntroduction:
          "Receiving rejection feedback can be disharetening, but understanding it can help you perform better in future interviews.",
        tip: "Don't take rejection personally—use it as a learning experience.",
        steps: [
          "Look for common themes in the feedback you receive.",
          "Understand if the rejection was due to skill gaps or cultural fit.",
          "Analyze whether you effectively communicated your strengths.",
          "Work on areas of improvement mentioned in the feedback.",
          "Consider seeking mentorship or additional training.",
          "Stay motivated and apply the learnings to your next interview.",
        ],
      },
      {
        id: 6,
        title: "The Role of Self-Assessment in Interview Success",
        description:
          "How to analyze your own performance and identify areas for improvement.",
        blogIntroduction:
          "Self-assessment is a powerful tool for continuous improvement. Evaluating your own interview performance can help you refine your approach for future opportunities.",
        tip: "Record yourself answering questions to identify areas for improvement.",
        steps: [
          "Reflect on how well you answered key interview questions.",
          "Assess your body language and tone of voice.",
          "Identify moments where you felt confident or hesitant.",
          "Note any questions that caught you off guard.",
          "Seek feedback from mentors or peers.",
          "Develop an improvement plan based on your observations.",
        ],
      },
    ],
    blogIntroduction:
      "Interview feedback is a crucial part of the hiring process, whether you are receiving feedback as a candidate or providing it as an interviewer. " +
      "Constructive feedback helps individuals understand their strengths and areas for improvement, ultimately leading to better interview performance in the future. " +
      "This guide will explore why feedback is important, how to request it, and how to use it effectively.",

    KeyPreparationSteps: [
      "Why Feedback Matters: Feedback helps candidates refine their skills, understand industry expectations, and improve future interviews.",
      "How to Request Feedback: If you don’t receive feedback after an interview, politely request it via email within a few days.",
      "Receiving Positive Feedback: If the feedback is positive, use it as motivation to maintain and enhance your strengths.",
      "Handling Constructive Criticism: View areas for improvement as opportunities for growth, not as personal failures.",
      "Common Reasons for Rejection: Learn from recruiter insights, such as lack of relevant experience, weak responses, or cultural misalignment.",
      "Providing Feedback as an Interviewer: Be clear, specific, and professional while giving feedback to candidates.",
      "Following Up After Feedback: Apply feedback to improve your interview skills and prepare more effectively for future opportunities.",
    ],

    FinalTip:
      "Feedback is a powerful tool for growth. Whether positive or constructive, use it as a stepping stone to enhance your interview skills. " +
      "Stay open to learning, continuously improve, and approach every interview as a chance to grow. " +
      "Remember, each interview—successful or not—brings you one step closer to your ideal job.",
  },
];

export const profileJobs = [
  {
    id: 1,
    title: "General Manager",
    location: "New York, NY 10004, USA",
    type: "Fulltime",
    mode: "Onsite",
    experience: "2-4 years",
    applicants: 521,
    posted: "2 days ago",
    salary: "$500/m",
    iconBg: "var(--portal-primary-color)",
  },
];

export const featuredJobs = [
  {
    id: 1,
    title: "General Manager",
    location: "New York, NY 10004, USA",
    type: "Fulltime",
    mode: "Onsite",
    experience: "2-4 years",
    applicants: 521,
    posted: "2 days ago",
    salary: "€500/m",
    iconBg: "var(--portal-primary-color)",

    description:
      "We are looking for a highly experienced General Manager to oversee daily operations, implement strategic plans, and lead a dynamic team. The ideal candidate should have excellent leadership and organizational skills, as well as experience in business development and financial planning.",

    jobRequirements: [
      "Experience in business development and financial planning.",
      "Strong leadership and decision-making skills.",
      "Ability to manage multiple teams and projects simultaneously.",
      "Proven experience in strategic planning and execution.",
    ],

    keyResponsibilities: [
      "Develop and implement business strategies to achieve company goals.",
      "Oversee daily operations and ensure smooth workflow.",
      "Lead and mentor teams to improve efficiency and productivity.",
      "Monitor financial performance and manage budgets.",
    ],

    qualifications: [
      "Bachelor’s or Master’s degree in Business Administration or related field.",
      "Minimum of 5 years of management experience.",
      "Excellent communication and organizational skills.",
    ],
  },
  {
    id: 2,
    title: "UI/UX Designer",
    location: "New York, NY 10004, USA",
    type: "Fulltime",
    mode: "Onsite",
    experience: "2-4 years",
    applicants: 521,
    posted: "2 days ago",
    salary: "€350/m",
    iconBg: "var(--portal-primary-color)",

    description:
      "Join our creative team as a UI/UX Designer, where you will be responsible for designing user-friendly interfaces, wireframes, and prototypes. You should have experience in Figma, Adobe XD, and usability testing. A strong portfolio showcasing previous projects is required.",

    jobRequirements: [
      "Experience with Figma, Adobe XD, and Sketch.",
      "Ability to conduct user research and usability testing.",
      "Strong portfolio showcasing previous UI/UX work.",
      "Understanding of design thinking and agile methodologies.",
    ],

    keyResponsibilities: [
      "Design and develop wireframes, prototypes, and user interfaces.",
      "Conduct user research and analyze usability tests.",
      "Collaborate with developers to ensure design consistency.",
      "Improve user experience through design enhancements.",
    ],

    qualifications: [
      "Bachelor’s degree in Design, Computer Science, or a related field.",
      "2+ years of experience in UI/UX design.",
      "Strong understanding of design tools like Figma, Sketch, or Adobe XD.",
    ],
  },
  {
    id: 3,
    title: "Software Engineer",
    location: "London, UK",
    type: "Fulltime",
    mode: "Hybrid",
    experience: "3-5 years",
    applicants: 378,
    posted: "5 days ago",
    salary: "€400/m",
    iconBg: "var(--portal-primary-color)",

    description:
      "We are hiring a skilled Software Engineer to develop scalable applications and contribute to the entire software development lifecycle. Strong knowledge of JavaScript, React.js, and Node.js is required. Experience with cloud platforms like AWS or Azure is a plus.",

    jobRequirements: [
      "Experience in JavaScript, React.js, and Node.js.",
      "Understanding of RESTful APIs and database design.",
      "Ability to work in an agile development environment.",
      "Experience with cloud platforms like AWS or Azure.",
    ],

    keyResponsibilities: [
      "Develop and maintain scalable web applications.",
      "Write clean, efficient, and reusable code.",
      "Collaborate with cross-functional teams to improve software performance.",
      "Troubleshoot and debug applications.",
    ],

    qualifications: [
      "Bachelor’s degree in Computer Science or related field.",
      "Minimum of 3 years of experience in software development.",
      "Proficiency in JavaScript, React.js, and Node.js.",
    ],
  },
  {
    id: 4,
    title: "Marketing Specialist",
    location: "Berlin, Germany",
    type: "Contract",
    mode: "Remote",
    experience: "1-3 years",
    applicants: 245,
    posted: "1 week ago",
    salary: "€300/m",
    iconBg: "var(--portal-primary-color)",

    description:
      "Seeking a Marketing Specialist to create and manage campaigns, analyze market trends, and improve brand awareness. Experience in digital marketing, SEO, and social media advertising is preferred. Strong communication and analytical skills are essential.",

    jobRequirements: [
      "Experience in digital marketing and social media advertising.",
      "Strong analytical skills for campaign performance tracking.",
      "Proficiency in marketing tools like Google Analytics and SEO.",
      "Ability to create compelling content and marketing strategies.",
    ],

    keyResponsibilities: [
      "Develop and execute marketing campaigns across various platforms.",
      "Monitor and analyze market trends and customer insights.",
      "Optimize campaigns for engagement and lead generation.",
      "Collaborate with the design and content teams for branding strategies.",
    ],

    qualifications: [
      "Bachelor’s degree in Marketing, Business, or related field.",
      "At least 1-3 years of experience in marketing.",
      "Strong communication and project management skills.",
    ],
  },
];

export const jobs = [
  {
    id: 1,
    title: "General Manager",
    location: "New York, NY 10004, USA",
    type: "Fulltime",
    mode: "Onsite",
    experience: "2-4 years",
    applicants: 521,
    posted: "2 days ago",
    salary: "€500/m",
    iconBg: "var(--portal-primary-color)",
  },
  {
    id: 2,
    title: "UI/UX Designer",
    location: "New York, NY 10004, USA",
    type: "Fulltime",
    mode: "Onsite",
    experience: "2-4 years",
    applicants: 521,
    posted: "2 days ago",
    salary: "€350/m",
    iconBg: "var(--portal-primary-color)",
  },
  {
    id: 3,
    title: "UI/UX Designer",
    location: "New York, NY 10004, UK",
    type: "Fulltime",
    mode: "Onsite",
    experience: "2-4 years",
    applicants: 521,
    posted: "2 days ago",
    salary: "€350/m",
    iconBg: "var(--portal-primary-color)",
  },
  {
    id: 4,
    title: "UI/UX Designer",
    location: "New York, NY 10004, UK",
    type: "Fulltime",
    mode: "Onsite",
    experience: "2-4 years",
    applicants: 521,
    posted: "2 days ago",
    salary: "€350/m",
    iconBg: "var(--portal-primary-color)",
  },
  {
    id: 5,
    title: "UI/UX Designer",
    location: "New York, NY 10004, UK",
    type: "Fulltime",
    mode: "Onsite",
    experience: "2-4 years",
    applicants: 521,
    posted: "2 days ago",
    salary: "€350/m",
    iconBg: "var(--portal-primary-color)",
  },
];
export const featuredPost = [
  { name: "Mitchell", sector: "Construction & Real Estate", logo: logo },
  { name: "Do Dublin Tours", sector: "Transportation", logo: logo },
  { name: "Mitchell", sector: "Construction & Real Estate", logo: logo },
  { name: "Do Dublin Tours", sector: "Transportation", logo: logo },
];
export const interViews = [
  { name: "Mitchell", sector: "Construction & Real Estate", logo: logo },
  { name: "Do Dublin Tours", sector: "Transportation", logo: logo },
  { name: "Mitchell", sector: "Construction & Real Estate", logo: logo },
  { name: "Do Dublin Tours", sector: "Transportation", logo: logo },
  { name: "Mitchell", sector: "Construction & Real Estate", logo: logo },

  {
    name: "Openmind Network Limited",
    sector: "Telecommunication",
    logo: logo,
  },
  {
    name: "Zinzino Independent",
    sector: "Health Care & Services",
    logo: logo,
  },
];
export const affiliationPartners = [
  {
    id: 1,
    name: "IHI – Irish Hospitality Institute",
    About:
      "IHI – Irish Hospitality Institutehe Irish Hospitality Institute was established in 1966 as the professional organization for managers in Ireland’s hotel, tourism, and catering sectors, collectively referred to as the hospitality industry. As a membership organization, the IHI prioritizes the professional interests and needs of managers within this field. Since its inception, the Irish Hospitality Institute has actively supported the career development of its members by offering conferences, seminars, networking opportunities, and various management development initiatives.Our mission is to foster the career growth of individuals in the hospitality industry by offering valuable insights, mentoring, networking opportunities, events, and by celebrating excellence throughout the sector.",
    sector: "Hospitality ",
    logo: aff1,
    Location: "Ireland",
    EstablishedIn: "no data",
    Website: "https://www.ihi.ie/",

    contact: {
      address:
        "Unit 11, The Courtyard, Kilcarbery Business Park, Nangor Road, Dublin 22, D22T860",
      email: "info@burrenamber.ie",
      phone: "+353 1 404 7620",
    },
    socialMedia: {
      facebook: "https://www.facebook.com/ihi.ie/",
      instagram:
        "https://x.com/i/flow/login?redirect_after_login=%2FIHI_Ireland",
      linkedIn:
        "https://www.linkedin.com/company/irish-hospitality-institute/posts/?feedView=all",
    },
  },
  {
    id: 2,
    name: "IHF – Irish Hotel Federation ",
    About:
      "The IHF was founded in 1937 as the official representative body for guesthouses and hotels in Ireland. The primary functions of the Federation are to promote and defend the interests of its members. The IHF represents almost 1,000 hotels and guesthouses nationwide, employing over 60,000 people and is a key stakeholder in the Irish tourism sector.",
    sector: " Professional Services/Staffing & Recruitment ",
    logo: aff3,
    Location: "Ireland",
    EstablishedIn: "2012",
    Website: "",
    contact: {
      address:
        "Unit 11, The Courtyard, Kilcarbery Business Park, Nangor Road, Dublin 22, D22T860",
      email: "reception@broadlinerecruiters.com",
      phone: "+353 1 404 7172",
    },
    socialMedia: {
      facebook: "",
      instagram: "",
      linkedIn: "https://www.linkedin.com/company/irishhotelsfederation/",
    },
  },
  {
    id: 3,
    name: "Chef Network",
    About:
      "We are Chef Network. An online community and professional network connecting chefs across the island of Ireland. Founded in 2016, Chef Network is open to chefs at all stages of their career from student chefs to retired chefs.Membership for Chefs & Student Chefs joining the network is completely FREE. ",
    logo: aff2,
    sector: "Hospitality",

    Location: "Ireland",
    EstablishedIn: "no data",
    Website: "https://www.chefnetwork.ie/",
    contact: {
      address: "The Laurels, 25 Main St, Tallaght, Co. Dublin, D24 E275",
      email: "info@hoteltalent.ie",
      phone: "+353 1 578 9690",
    },
    socialMedia: {
      facebook: "https://www.facebook.com/ChefNetworkIRL/",
      instagram: "https://www.instagram.com/chefnetworkirl/",
      linkedIn:
        "https://www.linkedin.com/company/chef-network/posts/?feedView=all",
    },
  },
];
export const recruitmentPartners = [
  {
    id: 1,
    name: "Burren Amber",
    About:
      "Burren Amber Recruiters is an established executive brand that focuses on connecting top hospitality and retail clients with the best available candidates in the market     The team is made up of recruiters whom were extremely successful in their field prior to joining and now utilise their in-depth industry knowledge to best understand both client and candidate’s needs,",
    Sector: " Professional Services/Staffing & Recruitment ",
    logo: rec1,
    Location: "Dublin",
    EstablishedIn: "no data",
    Website: "https://www.burrenamber.ie/",

    contact: {
      address:
        "Unit 11, The Courtyard, Kilcarbery Business Park, Nangor Road, Dublin 22, D22T860",
      email: "info@burrenamber.ie",
      phone: "+353 1 404 7620",
    },
    socialMedia: {
      facebook: "https://www.facebook.com/burrenamberrecruiters",
      instagram: "https://www.instagram.com/burrenamberrecruiters/",
      linkedIn:
        "https://www.linkedin.com/search/results/all/?keywords=burren&sid=TEw",
    },
  },
  {
    id: 2,
    name: "Broadline Group",
    About:
      "Broadline Group are one of Ireland’s leading recruitment agencies, supplying contract and permanent staff and training in each of our divisions to many of the largest national and multi-national companies in Ireland. Our dedicated teams of sector-specific recruitment specialists have the expertise to understand your company’s needs and aspirations and can help you secure your ideal employee whether on a contract or permanent placement.We know that people are fundamental to our business and central to everything we do is the desire to deliver the best possible outcome in the long-term interest of our Clients and Candidates. Whether for Contract or Permanent placement, we take particular care to ensure we exceed your expectations.",
    Sector: " Professional Services/Staffing & Recruitment ",
    logo: rec2,
    Location: "Ireland",
    EstablishedIn: "2012",
    Website: "https://broadlinegroup.ie/",
    contact: {
      address:
        "Unit 11, The Courtyard, Kilcarbery Business Park, Nangor Road, Dublin 22, D22T860",
      email: "reception@broadlinerecruiters.com",
      phone: "+353 1 404 7172",
    },
    socialMedia: {
      facebook: "https://www.facebook.com/BroadlineGroup",
      instagram: "https://www.instagram.com/broadlinegroup/",
      linkedIn: "https://www.linkedin.com/company/broadline-recruiters/",
    },
  },
  {
    id: 3,
    name: "Hotel Talent",
    About:
      "Hotel Talent is a premier recruitment agency specialising in hospitality and administrative staff for hotels and events. We offer permanent staffing solutions to the most prestigious hotels and event venues nationwide.Our expert recruitment team understands the unique needs of the hospitality industry and are dedicated to finding the perfect fit for your organization, whether it’s for short-term assignments or long-term positions.At Hotel Talent, we know that people are the core of our business. Our mission is to deliver outstanding results for both our clients and candidates. We strive to exceed your expectations by providing exceptional service and top-quality talent. ",
    logo: rec5,
    Sector: " Professional Services/Staffing & Recruitment ",

    Location: "Ireland",
    EstablishedIn: "2024",
    Website: "https://hoteltalent.ie/",
    contact: {
      address: "The Laurels, 25 Main St, Tallaght, Co. Dublin, D24 E275",
      email: "info@hoteltalent.ie",
      phone: "+353 1 578 9690",
    },
    socialMedia: {
      facebook: "https://www.facebook.com/profile.php?id=61564858095278",
      instagram: "https://www.instagram.com/_hoteltalent/",
      linkedIn:
        "https://www.linkedin.com/company/hotel_talent/?viewAsMember=true",
    },
  },
  {
    id: 4,
    name: "Chef Recruiters",
    About:
      "Chef Recruiters is an established recruitment agency specilaised in recruiting chefs nationwide. We understand  the requirements of the hospitality industry because we have worked in the industry. We pride ourselves on delivering to you our client at all times. We have the pleasure of working with some of the top chefs in the country, many of whom we continue to supply with talent today. Our vision for clients is clear: to source, reference and supply chefs that will suit your property both on the relief and/or full time permanent basis. Our drive for our candidate chefs is equally focused: We aim to recruit the leading chefs available in the industry and align them with the best kitchen environments.   When dealing with Chef Recruiters we ensure that our candidates and clients are treated with respect at all times. We listen to our clients at all times to ensure we understand what they are looking for. We understand our candidates and only put them forward for positions that they are suited for. We do not put CV’s out just for the sake of it with the aim of wasting people’s valuable time.   Ultimately, our ethos is to create a win-win situation for candidates and clients alike. Our recruiters have established backgrounds in each sector they represent. ",
    logo: rec3,
    Sector: " Professional Services/Staffing & Recruitment ",

    Location: "Ireland",
    EstablishedIn: "no data",
    Website: "https://www.chefrecruiters.ie/",
    contact: {
      address: "The Laurels, 25 Main St, Tallaght, Co. Dublin, D24 E275",
      email: "info@chefrecruiters.ie",
      phone: "+353 1 404 7176",
    },
    socialMedia: {
      facebook: "https://www.facebook.com/ChefRecruiters",
      instagram: "https://www.instagram.com/chefrecruiters/",
      linkedIn: "https://www.linkedin.com/company/chef-recruiters/",
    },
  },

  {
    id: 5,
    name: "Office Buddies",
    logo: rec6,
    EstablishedIn: "no data",

    About:
      "Office Buddies has its origins in Broadline Recruitment and was established to offer a specialized sector-specific service to the Commercial Sector...",
    Sector: "Professional Services/Staffing & Recruitment",
    Location: "Ireland",
    Website: "https://officebuddies.ie/",
    contact: {
      address:
        "Unit 11, The Courtyard, Kilcarbery Business Park, Nangor Road, Dublin 22, D22T860",
      email: "info@officebuddies.ie",
      phone: "+353 1 404 7170",
    },
    socialMedia: {
      facebook: "https://www.facebook.com/profile.php?id=100067063774128",
      instagram: "https://www.instagram.com/office_buddies/",
      linkedIn:
        "https://www.linkedin.com/company/office-buddies/?viewAsMember=true",
    },
  },
  {
    id: 6,
    name: "Executive Talent",
    logo: rec4,
    EstablishedIn: "no data",

    About:
      "The newest of Broadline Group Agencies, 'Executive Talent' is a specialist executive recruitment brand that is exclusively focused on placing managers at all levels across a range of industry sectors in Ireland...",
    Sector: "Professional Services/Staffing & Recruitment",
    Location: "Ireland",
    Website: "https://executivetalent.ie/",
    contact: {
      address:
        "Unit 11, The Courtyard, Kilcarbery Business Park, Nangor Road, Dublin 22, D22T860",
      email: "info@executivetalent.ie",
      phone: "+353 1 404 7675",
    },
    socialMedia: {
      facebook: "",
      instagram: "",
      linkedIn:
        "https://www.linkedin.com/search/results/all/?fetchDeterministicClustersOnly=true&heroEntityKey=urn%3Ali%3Aorganization%3A68334289&keywords=executive&sid=)de",
    },
  },
];

export const industryNews = [
  {
    name: "Industry news 1",
    sector: "Construction & Real Estate",
    logo: industryLogo,
  },
  { name: "Industry news 2", sector: "Transportation", logo: industryLogo },
  {
    name: "Industry news 3",
    sector: "Construction & Real Estate",
    logo: industryLogo,
  },
  { name: "Industry news 4", sector: "Transportation", logo: industryLogo },
  {
    name: "Industry news 5",
    sector: "Construction & Real Estate",
    logo: industryLogo,
  },
];

export const podcasts = [
  {
    name: "podcast 1",
    sector: "Construction & Real Estate",
    logo: podcatsLogo,
  },
  { name: "podcast 2", sector: "Transportation", logo: podcatsLogo },
  {
    name: "podcast 3",
    sector: "Construction & Real Estate",
    logo: podcatsLogo,
  },
  { name: "podcast 4", sector: "Transportation", logo: podcatsLogo },
  {
    name: "podcast 5",
    sector: "Construction & Real Estate",
    logo: podcatsLogo,
  },
];
export const partners = [
  { name: "Mitchell", sector: "Construction & Real Estate", logo: logo },
  { name: "Do Dublin Tours", sector: "Transportation", logo: logo },
  { name: "Mitchell", sector: "Construction & Real Estate", logo: logo },
  { name: "Do Dublin Tours", sector: "Transportation", logo: logo },
  { name: "Mitchell", sector: "Construction & Real Estate", logo: logo },

  {
    name: "Openmind Network Limited",
    sector: "Telecommunication",
    logo: logo,
  },
  {
    name: "Zinzino Independent",
    sector: "Health Care & Services",
    logo: logo,
  },
  {
    name: "Agilent Technology Ireland",
    sector: "Health Care",
    logo: logo,
  },
  {
    name: "Phibro Animal Health Ireland",
    sector: "Biotechnology & Pharmaceuticals",
    logo: logo,
  },
];

// the values for each set type in exercise is calculated from here against each vdot like
// if vdot is 30 and to get the value of selected type for that vdot it is used from here
// e_km_low stands easyLong Start range for km
// e_km_up stands easyLong ending range for km
// e_mi_low stands easyLong Start range for mile
// e_mi_up stands easyLong ending range for mile
// c_km stands compromised for km
// c_mi stands compromised for miles
// t_400_m stands threshold for 400 meters
// t_km stands threshold for km
// t_mi stands threshold for miles
// i_400_m stands interval for meters
// i_400_m stands interval for 400 meters
// i_km stands interval for km
// i_1200_m stands interval for 1200 meters
// i_mi stands interval for miles
// r_200_m stands repition for 200 meters
// r_300_m stands repition for 300 meters
// r_400_m stands repition for 400 meters
// r_600_m stands repition for 600 meters
// r_800_m stands repition for 800 meters

export function sort_array_based_on_createdAt(conversations) {
  return conversations.sort((a, b) => {
    const createdAtA = new Date(a.lastMessageDateTime || a.createdAt);
    const createdAtB = new Date(b.lastMessageDateTime || b.createdAt);
    return createdAtB - createdAtA;
  });
}

export const TimeZones = [
  "Europe/Andorra",
  "Asia/Dubai",
  "Asia/Kabul",
  "Europe/Tirane",
  "Asia/Yerevan",
  "Antarctica/Casey",
  "Antarctica/Davis",
  "Antarctica/DumontDUrville", // https://bugs.chromium.org/p/chromium/issues/detail?id=928068
  "Antarctica/Mawson",
  "Antarctica/Palmer",
  "Antarctica/Rothera",
  "Antarctica/Syowa",
  "Antarctica/Troll",
  "Antarctica/Vostok",
  "America/Argentina/Buenos_Aires",
  "America/Argentina/Cordoba",
  "America/Argentina/Salta",
  "America/Argentina/Jujuy",
  "America/Argentina/Tucuman",
  "America/Argentina/Catamarca",
  "America/Argentina/La_Rioja",
  "America/Argentina/San_Juan",
  "America/Argentina/Mendoza",
  "America/Argentina/San_Luis",
  "America/Argentina/Rio_Gallegos",
  "America/Argentina/Ushuaia",
  "Pacific/Pago_Pago",
  "Europe/Vienna",
  "Australia/Lord_Howe",
  "Antarctica/Macquarie",
  "Australia/Hobart",
  "Australia/Currie",
  "Australia/Melbourne",
  "Australia/Sydney",
  "Australia/Broken_Hill",
  "Australia/Brisbane",
  "Australia/Lindeman",
  "Australia/Adelaide",
  "Australia/Darwin",
  "Australia/Perth",
  "Australia/Eucla",
  "Asia/Baku",
  "America/Barbados",
  "Asia/Dhaka",
  "Europe/Brussels",
  "Europe/Sofia",
  "Atlantic/Bermuda",
  "Asia/Brunei",
  "America/La_Paz",
  "America/Noronha",
  "America/Belem",
  "America/Fortaleza",
  "America/Recife",
  "America/Araguaina",
  "America/Maceio",
  "America/Bahia",
  "America/Sao_Paulo",
  "America/Campo_Grande",
  "America/Cuiaba",
  "America/Santarem",
  "America/Porto_Velho",
  "America/Boa_Vista",
  "America/Manaus",
  "America/Eirunepe",
  "America/Rio_Branco",
  "America/Nassau",
  "Asia/Thimphu",
  "Europe/Minsk",
  "America/Belize",
  "America/St_Johns",
  "America/Halifax",
  "America/Glace_Bay",
  "America/Moncton",
  "America/Goose_Bay",
  "America/Blanc-Sablon",
  "America/Toronto",
  "America/Nipigon",
  "America/Thunder_Bay",
  "America/Iqaluit",
  "America/Pangnirtung",
  "America/Atikokan",
  "America/Winnipeg",
  "America/Rainy_River",
  "America/Resolute",
  "America/Rankin_Inlet",
  "America/Regina",
  "America/Swift_Current",
  "America/Edmonton",
  "America/Cambridge_Bay",
  "America/Yellowknife",
  "America/Inuvik",
  "America/Creston",
  "America/Dawson_Creek",
  "America/Fort_Nelson",
  "America/Vancouver",
  "America/Whitehorse",
  "America/Dawson",
  "Indian/Cocos",
  "Europe/Zurich",
  "Africa/Abidjan",
  "Pacific/Rarotonga",
  "America/Santiago",
  "America/Punta_Arenas",
  "Pacific/Easter",
  "Asia/Shanghai",
  "Asia/Urumqi",
  "America/Bogota",
  "America/Costa_Rica",
  "America/Havana",
  "Atlantic/Cape_Verde",
  "America/Curacao",
  "Indian/Christmas",
  "Asia/Nicosia",
  "Asia/Famagusta",
  "Europe/Prague",
  "Europe/Berlin",
  "Europe/Copenhagen",
  "America/Santo_Domingo",
  "Africa/Algiers",
  "America/Guayaquil",
  "Pacific/Galapagos",
  "Europe/Tallinn",
  "Africa/Cairo",
  "Africa/El_Aaiun",
  "Europe/Madrid",
  "Africa/Ceuta",
  "Atlantic/Canary",
  "Europe/Helsinki",
  "Pacific/Fiji",
  "Atlantic/Stanley",
  "Pacific/Chuuk",
  "Pacific/Pohnpei",
  "Pacific/Kosrae",
  "Atlantic/Faroe",
  "Europe/Paris",
  "Europe/London",
  "Asia/Tbilisi",
  "America/Cayenne",
  "Africa/Accra",
  "Europe/Gibraltar",
  "America/Godthab",
  "America/Danmarkshavn",
  "America/Scoresbysund",
  "America/Thule",
  "Europe/Athens",
  "Atlantic/South_Georgia",
  "America/Guatemala",
  "Pacific/Guam",
  "Africa/Bissau",
  "America/Guyana",
  "Asia/Hong_Kong",
  "America/Tegucigalpa",
  "America/Port-au-Prince",
  "Europe/Budapest",
  "Asia/Jakarta",
  "Asia/Pontianak",
  "Asia/Makassar",
  "Asia/Jayapura",
  "Europe/Dublin",
  "Asia/Jerusalem",
  "Asia/Kolkata",
  "Indian/Chagos",
  "Asia/Baghdad",
  "Asia/Tehran",
  "Atlantic/Reykjavik",
  "Europe/Rome",
  "America/Jamaica",
  "Asia/Amman",
  "Asia/Tokyo",
  "Africa/Nairobi",
  "Asia/Bishkek",
  "Pacific/Tarawa",
  "Pacific/Enderbury",
  "Pacific/Kiritimati",
  "Asia/Pyongyang",
  "Asia/Seoul",
  "Asia/Almaty",
  "Asia/Qyzylorda",
  "Asia/Qostanay", // https://bugs.chromium.org/p/chromium/issues/detail?id=928068
  "Asia/Aqtobe",
  "Asia/Aqtau",
  "Asia/Atyrau",
  "Asia/Oral",
  "Asia/Beirut",
  "Asia/Colombo",
  "Africa/Monrovia",
  "Europe/Vilnius",
  "Europe/Luxembourg",
  "Europe/Riga",
  "Africa/Tripoli",
  "Africa/Casablanca",
  "Europe/Monaco",
  "Europe/Chisinau",
  "Pacific/Majuro",
  "Pacific/Kwajalein",
  "Asia/Yangon",
  "Asia/Ulaanbaatar",
  "Asia/Hovd",
  "Asia/Choibalsan",
  "Asia/Macau",
  "America/Martinique",
  "Europe/Malta",
  "Indian/Mauritius",
  "Indian/Maldives",
  "America/Mexico_City",
  "America/Cancun",
  "America/Merida",
  "America/Monterrey",
  "America/Matamoros",
  "America/Mazatlan",
  "America/Chihuahua",
  "America/Ojinaga",
  "America/Hermosillo",
  "America/Tijuana",
  "America/Bahia_Banderas",
  "Asia/Kuala_Lumpur",
  "Asia/Kuching",
  "Africa/Maputo",
  "Africa/Windhoek",
  "Pacific/Noumea",
  "Pacific/Norfolk",
  "Africa/Lagos",
  "America/Managua",
  "Europe/Amsterdam",
  "Europe/Oslo",
  "Asia/Kathmandu",
  "Pacific/Nauru",
  "Pacific/Niue",
  "Pacific/Auckland",
  "Pacific/Chatham",
  "America/Panama",
  "America/Lima",
  "Pacific/Tahiti",
  "Pacific/Marquesas",
  "Pacific/Gambier",
  "Pacific/Port_Moresby",
  "Pacific/Bougainville",
  "Asia/Manila",
  "Asia/Karachi",
  "Europe/Warsaw",
  "America/Miquelon",
  "Pacific/Pitcairn",
  "America/Puerto_Rico",
  "Asia/Gaza",
  "Asia/Hebron",
  "Europe/Lisbon",
  "Atlantic/Madeira",
  "Atlantic/Azores",
  "Pacific/Palau",
  "America/Asuncion",
  "Asia/Qatar",
  "Indian/Reunion",
  "Europe/Bucharest",
  "Europe/Belgrade",
  "Europe/Kaliningrad",
  "Europe/Moscow",
  "Europe/Simferopol",
  "Europe/Kirov",
  "Europe/Astrakhan",
  "Europe/Volgograd",
  "Europe/Saratov",
  "Europe/Ulyanovsk",
  "Europe/Samara",
  "Asia/Yekaterinburg",
  "Asia/Omsk",
  "Asia/Novosibirsk",
  "Asia/Barnaul",
  "Asia/Tomsk",
  "Asia/Novokuznetsk",
  "Asia/Krasnoyarsk",
  "Asia/Irkutsk",
  "Asia/Chita",
  "Asia/Yakutsk",
  "Asia/Khandyga",
  "Asia/Vladivostok",
  "Asia/Ust-Nera",
  "Asia/Magadan",
  "Asia/Sakhalin",
  "Asia/Srednekolymsk",
  "Asia/Kamchatka",
  "Asia/Anadyr",
  "Asia/Riyadh",
  "Pacific/Guadalcanal",
  "Indian/Mahe",
  "Africa/Khartoum",
  "Europe/Stockholm",
  "Asia/Singapore",
  "America/Paramaribo",
  "Africa/Juba",
  "Africa/Sao_Tome",
  "America/El_Salvador",
  "Asia/Damascus",
  "America/Grand_Turk",
  "Africa/Ndjamena",
  "Indian/Kerguelen",
  "Asia/Bangkok",
  "Asia/Dushanbe",
  "Pacific/Fakaofo",
  "Asia/Dili",
  "Asia/Ashgabat",
  "Africa/Tunis",
  "Pacific/Tongatapu",
  "Europe/Istanbul",
  "America/Port_of_Spain",
  "Pacific/Funafuti",
  "Asia/Taipei",
  "Europe/Kiev",
  "Europe/Uzhgorod",
  "Europe/Zaporozhye",
  "Pacific/Wake",
  "America/New_York",
  "America/Detroit",
  "America/Kentucky/Louisville",
  "America/Kentucky/Monticello",
  "America/Indiana/Indianapolis",
  "America/Indiana/Vincennes",
  "America/Indiana/Winamac",
  "America/Indiana/Marengo",
  "America/Indiana/Petersburg",
  "America/Indiana/Vevay",
  "America/Chicago",
  "America/Indiana/Tell_City",
  "America/Indiana/Knox",
  "America/Menominee",
  "America/North_Dakota/Center",
  "America/North_Dakota/New_Salem",
  "America/North_Dakota/Beulah",
  "America/Denver",
  "America/Boise",
  "America/Phoenix",
  "America/Los_Angeles",
  "America/Anchorage",
  "America/Juneau",
  "America/Sitka",
  "America/Metlakatla",
  "America/Yakutat",
  "America/Nome",
  "America/Adak",
  "Pacific/Honolulu",
  "America/Montevideo",
  "Asia/Samarkand",
  "Asia/Tashkent",
  "America/Caracas",
  "Asia/Ho_Chi_Minh",
  "Pacific/Efate",
  "Pacific/Wallis",
  "Pacific/Apia",
  "Africa/Johannesburg",
];

export const main_color_skin_sister = "#b7849b";
export const formatDescription = (text) => {
  if (!text) return "";
  const safeText = typeof text === "string" ? text : String(text);
  return safeText.split("\n").map((line, index) => (
    <span key={index}>
      {line}
      <br />
    </span>
  ));
};
export const parseDescriptionWithLink = (description) => {
  const urlRegex = /((?:https?:\/\/|www\.)[^\s]+)/gi;
  const elements = [];
  let lastIndex = 0;

  const matches = [...description.matchAll(urlRegex)];

  matches.forEach((match, index) => {
    const url = match[0];
    const start = match.index;

    // Add plain text before URL
    if (start > lastIndex) {
      elements.push(
        <span key={`text-${index}`}>{description.slice(lastIndex, start)}</span>
      );
    }

    // Normalize www. to https://
    const href = url.startsWith("www.") ? `https://${url}` : url;

    elements.push(
      <a
        key={`link-${index}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#1976d2", textDecoration: "underline" }}
      >
        {url}
      </a>
    );

    lastIndex = start + url.length;
  });

  // Add remaining plain text
  if (lastIndex < description.length) {
    elements.push(<span key="last">{description.slice(lastIndex)}</span>);
  }

  return elements;
};

// Test component
const DescriptionRenderer = () => {
  const description =
    "Visit www.amazon.com and also check https://openai.com or www.whiteboard.com.";

  return <div>{parseDescriptionWithLink(description)}</div>;
};
export const convertCurrencyToSignNew = (cur) => {
  let currency = cur.toUpperCase();
  if (currency === "GBP") {
    return "£";
  } else if (currency === "EUR") {
    return "€";
  } else if (currency === "USD") {
    return "$";
  } else {
    return "";
  }
};
const is_safari = () => {
  const userAgent = window.navigator.userAgent;
  let get_browser = (type) => userAgent.indexOf(type) !== -1;
  if (get_browser("Chrome") && get_browser("Safari")) {
    return false;
  } else if (userAgent.indexOf("Safari") !== -1) {
    return true;
  } else {
    return false;
  }
};
export const handle_open_browser = (link) => {
  if (is_safari()) {
    window.open(link, "_self");
  } else {
    window.open(link);
  }
};

let timer;
export const debounce = (func, timeout = 300) => {
  clearTimeout(timer);
  timer = setTimeout(() => {
    func();
  }, timeout);
};

export const getFileIcon = (fileUrl, size = 35) => {
  if (!fileUrl) return <InsertDriveFileOutlined sx={{ fontSize: size }} />;

  const extension = fileUrl.split(".").pop().toLowerCase();

  switch (extension) {
    case "pdf":
      return (
        <img src={pdfImage} alt="pdf" style={{ width: size, height: size }} />
      );
    case "doc":
    case "docx":
      return (
        <img src={wordImage} alt="word" style={{ width: size, height: size }} />
      );
    case "xls":
    case "xlsx":
      return (
        <img
          src={xlsxImage}
          alt="excel"
          style={{ width: size, height: size }}
        />
      );
    case "csv":
      return (
        <img src={csvImage} alt="csv" style={{ width: size, height: size }} />
      );
    case "mp3":
    case "wav":
      return (
        <img
          src={audioImage}
          alt="audio"
          style={{ width: size, height: size }}
        />
      );
    default:
      return (
        <img
          src={otherImage}
          alt="other"
          style={{ width: size, height: size }}
        />
      );
  }
};

export const formatSalary = (value) => {
  if (value === null || value === undefined || value === "") return "N/A";
  const num = Number(value);
  if (isNaN(num)) return value; // agar number na ho to jaisa hai waisa dikhao

  // Agar integer hai to as-it-is show karo, warna 2 decimals
  return Number.isInteger(num) ? num.toString() : num.toFixed(2);
};
export const getHeaderIcon = (heading) => {
  console.log(heading, "headingheadingheading");
  if (!heading) return null;

  if (heading.toLowerCase().includes("delete")) {
    return deleteIcon;
  } else if (
    heading.toLowerCase().includes("renew") ||
    heading.toLowerCase().includes("refresh")
  ) {
    return RefreshIcon;
  } else if (
    heading.toLowerCase().includes("sign out") ||
    heading.toLowerCase().includes("logout")
  ) {
    return WarningIcon;
  }
  return null;
};
